<template>
  <div class="home dqdkxx bakcovzz"  >
    <div style="height:100%;width: 100%;position: relative;z-index: -1;" >
      <div class="mapLf" v-if="formattedmstype==false"></div>
      <div class="mapRt" v-if="formattedmstype==false"></div>
      <div class="mapBtm" v-if="formattedmstype==false"></div>
      <div class="mapTop" ></div>
      <div id="cyswcontainer" ></div>
      <div v-if="showTooltip" :style="tooltipStyle" class="tooltip">
        {{ tooltipContent }}
      </div>
    </div>
    <el-dialog
      width="70%"
      top="160px" 
      :visible.sync="mapzddialogTableVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
    >
      <div class="tz_cov_chanye" style="height: 670px">
        <img
          src="@/assets/images/guanbi.png"
          class="guanbiann"
          @click="qcguanbi"
          alt=""
        />
        <div class="tz_cov_topchanye">
          <span class="tz_cov_top_tit">当前地块信息</span>
        </div>
        <div class="dqdkcov">
            <div class="qddkLf">
                <span class="qddkLf_tit">地块:{{landDetailShow.landName}}</span>
                <div class="qddkLf_cov">
                  <div id="onemapcontainer" ></div>
                </div>
            </div>
            <div class="qddkRt">
                <div class="qddkRt_top">
                  <div class="qddkRt_nav">
                      <span class="qddkNav_name" @click="dikuaiClick('jcxx')">基础信息</span>
                      <span class="qddkNav_name" @click="dikuaiClick('zypz')">种养品种</span>
                      <span class="qddkNav_name" @click="dikuaiClick('nscz')">农事记录</span>
                  </div>
                  <div class="qddkRt_hov" v-if="dikuaiHover==1"  @click="dikuaiClick('jcxx')"> <span class="tit">基础信息</span> </div>
                  <div class="qddkRt_hov2" v-else-if="dikuaiHover==2" @click="dikuaiClick('zypz')"> <span class="tit">种养品种</span> </div>
                  <div class="qddkRt_hov3" v-else  @click="dikuaiClick('nscz')"> <span class="tit">农事记录</span> </div>
                </div>
                <div class="qddkRt_con" v-if="dikuaiHover==1" >
                    <div class="qddkconList">
                        <span class="dkname">地块名称</span>
                        <span class="dknum">{{landDetailShow.landName}}</span>
                    </div>
                    <div class="qddkconList">
                        <span class="dkname">地块面积</span>
                        <span class="dknum"> <span class="nmber">{{landDetailShow.landAcre}}</span> <span class="danwei">{{landDetailShow.landAcreUnit_dictText}}</span></span>
                    </div>
                    <div class="qddkconList">
                        <span class="dkname">地块类型</span>
                        <span class="dknum">{{landDetailShow.landTypeId_dictText}}</span>
                    </div>
                    <div class="qddkconList">
                        <span class="dkname">地块开始时间</span>
                        <span class="dknum">{{landDetailShow.landStartTime}}</span>
                    </div>
                    <div class="qddkconBtn" @click="dikuaishow(landDetailShow)">
                      <transition name="topcov" appear >
                          <div class="qddkconBtn_con"></div>
                      </transition> 
                      <span class="qddkconBtn_name">进入地块详情</span>
                    </div>
                </div>
                <div class="qddkRt_con2" v-if="dikuaiHover==2">
                    <div v-if="landDetailShow.plantList.length>0">
                        <div class="dkzyList" v-for="(item,index) in landDetailShow.plantList" :key="index">
                            <img :src="item.imgUrl" class="dkzyListimg" alt="" />
                            <div class="dkzyList_rit">
                                <span class="name">{{item.cropName}}</span>
                                <span class="time">{{item.plantStartDate}}  播种 第{{item.plantDay}}天</span>
                            </div>
                        </div>
                    </div>
                    <img v-else src="@/assets/images/nonenum.png" alt="" style="width:200px;margin-top:100px;">
                </div>
                <div class="qddkRt_con3" v-if="dikuaiHover==3" >
                    <div class="nsczNt" v-if="landDetailShow.fmissions.length>0">
                        <vue-seamless-scroll :data="landDetailShow.fmissions"  :class-option="optionSetting" >
                          <el-timeline>
                            <el-timeline-item hide-timestamp v-for="(item,index) in landDetailShow.fmissions" :key="index" placement="top">
                              <div class="el-timeline-item__timestamp2 is-top">
                                  <span>{{ item.fplant.landName }} <span style="float:right;margin-right:2%;">{{ item.startTime.slice(0, 16) }}</span> </span> 
                              </div>
                              <div class="stCovTc" style="height:auto;">
                                <span>{{item.completeOperTime}} {{item.chargeUserName}} 在地块上进行 "{{item.missionName}}" </span>
                                <div class="imgList" v-if="item.feedbackImgUrls">
                                  <viewer  >
                                    <img  :src="urlimg+item" v-for="(item,index) in item.feedbackImgUrls.split(',')"  :key="index"  alt="" class="stCovimg">
                                  </viewer>
                                </div>
                              </div>
                            </el-timeline-item>
                          </el-timeline>
                        </vue-seamless-scroll>
                    </div>
                    <img v-else src="@/assets/images/nonenum.png" alt="" style="width:200px;margin-top:100px;">
                </div>
            </div>
        </div>
      </div>
    </el-dialog>
    <div class="home_leftcy">
      <transition name="yqgk" appear  v-if="formattedmstype==false">
          <TitWorld msg="基地概况" />
      </transition>
      <transition name="yqgk" appear v-if="formattedmstype==false">
          <div  v-loading="survData?loading==false:loading==true" element-loading-background="rgba(0, 0, 0, 0.8)" >
            <YkgkCov v-if="numbValue" :numbValue="numbValue" :farmId="farmId" :urlimg="urlimg"  />
            <img  v-else src="@/assets/images/nonenum.png" alt="" style="margin-top:210px;margin-bottom:220px;">
          </div>
      </transition>
      <transition name="dlhj" appear v-if="formattedmstype==false">
          <TitWorld msg="种植作物" />
      </transition>
      <transition name="dlhj" appear v-if="formattedmstype==false">
          <div  v-loading="zzzwList.length>0?loading==false:loading==true" element-loading-background="rgba(0, 0, 0, 0.8)" >
            <ZzzwCov v-if="zzzwList.length>0" :zzzwList="zzzwList" :farmId="farmId" :urlimg="urlimg" />
            <img  v-else src="@/assets/images/nonenum.png" alt="" style="margin-top:30px;">
          </div>
      </transition>
    </div>
    <div class="home_rightcy">
        <transition name="zdcy" appear  v-if="formattedmstype==false">
            <TitWorld msg="物联设备" />
        </transition>
        <transition name="zdcy" appear v-if="formattedmstype==false">
          <div  v-loading="survData?loading==false:loading==true" element-loading-background="rgba(0, 0, 0, 0.8)" >
            <WlsbCov v-if="survData&&VideoList&&cameraValue" :auths="auths" :survData="survData" :urlimg="urlimg"   :cameraValue="cameraValue" :VideoList="VideoList" @handleCurrentChange="handleCurrentChange"/>
            <img v-else src="@/assets/images/nonenum.png" alt="" style="margin:190px 0px;">
          </div>
        </transition>
        <transition name="jyzt" appear v-if="formattedmstype==false">
            <TitWorld msg="生态预警" />
        </transition>
        <transition name="jyzt" appear v-if="formattedmstype==false">
          <NsjlCov @yj-souw="yjsouw" ref="childRef" :farmId="farmId" :auths="auths" />
        </transition>
    </div>
    <transition name="topcovbtm" appear v-if="formattedmstype==false">
        <BtmCov v-if="onephoto.length>0" :onephoto="onephoto" :farmId="farmId" :urlimg="urlimg"  />
    </transition>
    <!-- 经营主体列表 -->
    <transition name="topcov2" v-if="laorshou==true" appear>
      <div :class="formattedmstype==false?'jingyzhut':'jingyzhutover'" >
          基地作物
        </div>
    </transition>
    <transition name="topcov" v-if="laorshou==true" appear>
      <div :class="formattedmstype==false?'jyztzhankai':'jyztzhankaiover'"  @click="lashou">
        展开
        <img src="@/assets/images/xlxiala.png" class="xlxiala" alt="" />
      </div>
    </transition>
    <transition name="xialatran" appear >
      <div :class="formattedmstype==false?'jyztshow':'jyztshowover'" v-if="laorshou==false">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="种植作物" name="first">
            <div class="jyztList2" v-for="(item,index) in zzzwList" :key="index" @click="zuowushow(item,index)">
              <img :src="item.cropPics" alt="">
              <span class="qiyname2" >{{item.cropName}}</span>
            </div>
          </el-tab-pane>
          <el-tab-pane label="地块" name="second">
            <!-- <div class="sousuo">
              <el-input
                size="medium "
                placeholder="请输入内容"
                prefix-icon="el-icon-search"
                v-model="inputsous">
              </el-input>
            </div> -->
            <div class="jyztList" v-for="(item,index) in landListShow" :key="index" @click="zuowushow(item,index,'land')">
              <span class="qiyname">{{item.landName}}</span>
              <span class="qiyxinz"><img src="@/assets/images/Group01.png" alt=""></span>
              <img src="@/assets/images/xlgo.png" class="xlgo" alt="" />
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="shouqi" @click="lashou">
          收起
          <img src="@/assets/images/xlshouqi.png" class="xlxiala" alt="" />
        </div>
      </div>
    </transition>
     <!-- 经营主体列表结束 --> 
    <!-- 空气弹窗 -->
    <el-dialog
      width="70%"
      top="160px"
      :visible.sync="qczddialogTableVisible"
      :modal-append-to-body="false"
	    :destroy-on-close="true"
      v-if="qczddialogTableVisible"
    >
      <div class="tzqx_cov_chanye" style="height: 670px">
        <img
          src="@/assets/images/guanbi.png"
          class="guanbiann"
          @click="qcguanbi"
          alt=""
        />
        <div class="tz_cov_topchanye">
          <span class="tz_cov_top_tit">气象环境监测</span>
        </div>
        <el-row class="tz_cov_topyqjs">
          <el-col :span="10">
            <div class="grid-content bg-purple ycboxlt4">
				<span class="tcxitit" >实时监测信息</span>
                <div class="qxsjssjcTc">
					<div class="qxsjssjc_leftTc">
						<div class="qxsjssjc_left_list shouxing" v-if="fengx" @click="cyzxshow(fengx)">
							<span class="qxsjssjc_left_list_show" v-if="348.76 < fengx.value || fengx.value < 11.25">北风</span>
							<span class="qxsjssjc_left_list_show" v-else-if="11.26 < fengx.value < 33.75">北东北</span>
							<span class="qxsjssjc_left_list_show" v-else-if="33.76 < fengx.value < 56.25">东北</span>
							<span class="qxsjssjc_left_list_show" v-else-if="56.26 < fengx.value < 78.75">东东北</span>
							<span class="qxsjssjc_left_list_show" v-else-if="78.76 < fengx.value < 101.25">东</span>
							<span class="qxsjssjc_left_list_show" v-else-if="101.26 < fengx.value < 123.75">东东南</span>
							<span class="qxsjssjc_left_list_show" v-else-if="123.76 < fengx.value < 146.25">东南</span>
							<span class="qxsjssjc_left_list_show" v-else-if="146.26 < fengx.value < 168.75">南东南</span>
							<span class="qxsjssjc_left_list_show" v-else-if="168.76 < fengx.value < 191.25">南</span>
							<span class="qxsjssjc_left_list_show" v-else-if="191.26 < fengx.value < 213.75">南西南</span>
							<span class="qxsjssjc_left_list_show" v-else-if="213.76 < fengx.value < 236.25">西南</span>
							<span class="qxsjssjc_left_list_show" v-else-if="236.26 < fengx.value < 258.75">西西南</span>
							<span class="qxsjssjc_left_list_show" v-else-if="258.76 < fengx.value < 281.25">西</span>
							<span class="qxsjssjc_left_list_show" v-else-if="281.26 < fengx.value < 303.75">西西北</span>
							<span class="qxsjssjc_left_list_show" v-else-if="303.76 < fengx.value < 326.25">西北</span>
							<span class="qxsjssjc_left_list_show" v-else-if="337.5 < fengx.value < 348.75">北西北</span>
							<span class="qxsjssjc_left_list_show" v-else>静风</span>
							<div class="qxsjssjc_left_list_tit">
								{{fengx.name}}
							</div>
						</div>
						<div class="qxsjssjc_left_list shouxing" v-if="zhaodu" @click="cyzxshow(zhaodu)">
							<span class="qxsjssjc_left_list_show">
								<animate-number  class="in1con_lf_imglf_num_jix" ref="reNum11" from="0" :to="zhaodu.value" :key="zhaodu.value" duration="3000"></animate-number>
							{{zhaodu.unit}}</span>
							<div class="qxsjssjc_left_list_tit">
								{{zhaodu.name}}
							</div>
						</div>
						<div class="qxsjssjc_left_list shouxing" v-if="yuliang" @click="cyzxshow(yuliang)" style="margin-top:1.5vw;">
							<span class="qxsjssjc_left_list_show">
								<animate-number  class="in1con_lf_imglf_num_jix" ref="reNum13" from="0" :to="yuliang.value" :key="yuliang.value" duration="3000"></animate-number>
							{{yuliang.unit}}</span>
							<div class="qxsjssjc_left_list_tit">
								{{yuliang.name}}
							</div>
						</div>
					</div>
					
					<div class="qxjcimg2">
						<img src="@/assets/images/tcdiqx.png" class="tcyqimg"  alt="">
						<img src="@/assets/images/tcdidizuo.png" class="tcdzimg" alt="">
					</div>
					<div class="qxsjssjc_leftTc2">
						<div class="qxsjssjc_left_list shouxing" v-if="fengs" @click="cyzxshow(fengs)">
							<span class="qxsjssjc_left_list_show">
								<animate-number  class="in1con_lf_imglf_num_jix" ref="reNum14" from="0" :to="fengs.value" :key="fengs.value" duration="3000"></animate-number>
								{{fengs.unit}}</span>
							<div class="qxsjssjc_left_list_tit">
								{{fengs.name}}
							</div>
						</div>
						<div class="qxsjssjc_left_list shouxing" v-if="dqwd" @click="cyzxshow(dqwd)">
							<span class="qxsjssjc_left_list_show">
								<animate-number  class="in1con_lf_imglf_num_jix" ref="reNum15" from="0" :to="dqwd.value" :key="dqwd.value" duration="3000"></animate-number>
								{{dqwd.unit}}</span>
							<div class="qxsjssjc_left_list_tit">
								{{dqwd.name}}
							</div>
						</div>
						<div class="qxsjssjc_left_list shouxing" v-if="dqsd" @click="cyzxshow(dqsd)" >
							<span class="qxsjssjc_left_list_show">
								<animate-number  class="in1con_lf_imglf_num_jix" ref="reNum16" from="0" :to="dqsd.value" :key="dqsd.value" duration="3000"></animate-number>
								{{dqsd.unit}}</span>
							<div class="qxsjssjc_left_list_tit">
								{{dqsd.name}}
							</div>
						</div>
						<div class="qxsjssjc_left_list shouxing" v-if="dqyl" @click="cyzxshow(dqyl)">
							<span class="qxsjssjc_left_list_show">
								<animate-number  class="in1con_lf_imglf_num_jix" ref="reNum17" from="0" :to="dqyl.value" :key="dqyl.value" duration="3000"></animate-number>
								{{dqyl.unit}}</span>
							<div class="qxsjssjc_left_list_tit">
								{{dqyl.name}}
							</div>
						</div>
					</div>
				</div>
            </div>
          </el-col>
          <el-col :span="14">
            <span class="tcxitit">气象监测历史记录</span>
			<div class="bianqianlist">
				<div :class="time==1?'xiaoshiHover':'xiaoshi'" @click="timeqieh('xiao')">小时</div>
				<div :class="time==2?'xiaoshiHover':'xiaoshi'" @click="timeqieh('ri')">日均</div>
				<div :class="time==3?'xiaoshiHover':'xiaoshi'" @click="timeqieh('yue')">月均</div>
				<el-date-picker
					v-model="value1"
					class="custom-date-picker"
					type="date"
					size="small"
					@blur="timetrpicker"
					style="float:left;margin-left:10px;"
					placeholder="选择日期">
				</el-date-picker>
				<div class="xiaoshiHover" @click="tanchuangshuj" >查询</div>
				<div class="zsfsList">
					展示方式：
					<el-radio-group v-model="radio1" @input="numtab" size="small" fill="#04A66F" >
						<el-radio-button label="折线"></el-radio-button>
						<el-radio-button label="表格"></el-radio-button>
					</el-radio-group>
				</div>
			</div>
			<div ref="columnzxEchart" v-if="tabnum==true" style="width: 100%; height: 480px;"></div>
			<el-table
			    v-else
				:data="formListVlaue"
				height="480"
				border
				style="width: 100%;">
				<el-table-column
				prop="date"
				label="时间"
				width="360">
				</el-table-column>
				<el-table-column
				prop="name"
				:label="'数值单位：' + unitValue">
				</el-table-column>
			</el-table>
			<div class="loader" v-if="lodshow==true">
				<div class="loader-inner ball-grid-pulse">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
				<span class="lodingspan">加载中......</span>
			</div>

          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!-- 土壤弹窗 -->
    <el-dialog
      width="70%"
      top="160px"
      :visible.sync="trzddialogTableVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      v-if="trzddialogTableVisible"
    >
      <div class="tztr_cov_chanye" style="height: 670px">
        <img
          src="@/assets/images/guanbi.png"
          class="guanbiann"
          @click="qcguanbi"
          alt=""
        />
        <div class="tz_cov_topchanye">
          <span class="tz_cov_top_tit">土壤环境监测</span>
        </div>
        <el-row class="tz_cov_topyqjs">
          <el-col :span="10">
            <div class="grid-content bg-purple ycboxlt4">
              <span class="tcxitit" >实时监测信息</span>
              <div class="qxsjssjcTc" @click.stop="trzxshow($event)">
                <div class="qxsjssjc_left" style="margin-top:20px;">
                  <el-col :span="24" class="tcgd2"  style="padding: 0px" v-for="(item, index) in airDataListHome1" :key="index" :data-item="JSON.stringify(item)">
                      <div class="jcsjtclist"  style="overflow: hidden" >
                        <el-row >
                          <el-col :span="10">
                            <img :src="urlimg+item.bsIcon" alt="" class="jcsjicon1" />
                          </el-col>
                          <el-col :span="14">
                            <span class="jcsjicon1_tit">{{ item.name }}   </span>
                            <button type="button" @click="startAnimate()" style="display: none"></button>
                            <span class="jcsjicon1_num" v-if="item.value == '0' || item.value == '0.0'|| item.value == undefined" >
                              <span>0</span>
                              <span class="jcsjicon1_dan">{{ item.unit }}</span>
                            </span>
                            <span class="jcsjicon1_num" v-else>
                              <animate-number style="display:none;" ref="myNum1" from="0" :to="item.value" :key="item.value" duration="3000" ></animate-number>
                              <span >{{item.value}}</span>
                              <span class="jcsjicon1_dan">{{ item.unit }}</span>
                            </span>
                          </el-col>
                        </el-row>
                      </div>
                  </el-col>
                </div>
                
                <div class="qxjcimg2">
                  <img src="@/assets/images/tcditr.png" class="tcyqimg"  alt="">
                  <img src="@/assets/images/tcdidizuo.png" class="tcdzimg" alt="">
                </div>
                <div class="qxsjssjc_right" style="margin-top:20px;">
                  <el-col :span="24" class="tcgd2"  style="padding: 0px" v-for="(item, index) in airDataListHome2" :key="index" :data-item="JSON.stringify(item)">
                      <div class="jcsjtclist"  style="overflow: hidden" >
                        <el-row >
                          <el-col :span="10">
                            <img :src="urlimg+item.bsIcon" alt="" class="jcsjicon1" />
                          </el-col>
                          <el-col :span="14">
                            <span class="jcsjicon1_tit">{{ item.name }}   </span>
                            <button type="button" @click="startAnimate()" style="display: none"></button>
                            <span class="jcsjicon1_num" v-if="item.value == '0' || item.value == '0.0'|| item.value == undefined" >
                              <span>0</span>
                              <span class="jcsjicon1_dan">{{ item.unit }}</span>
                            </span>
                            <span class="jcsjicon1_num" v-else>
                              <animate-number style="display:none;" ref="myNum1" from="0" :to="item.value" :key="item.value" duration="3000" ></animate-number>
                              <span >{{item.value}}</span>
                              <span class="jcsjicon1_dan">{{ item.unit }}</span>
                            </span>
                          </el-col>
                        </el-row>
                      </div>
                  </el-col>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="14">
            <span class="tcxitit">土壤监测历史记录</span>
              <div class="bianqianlist">
                <div :class="time==1?'xiaoshiHover':'xiaoshi'" @click="timeqieh('xiao')">小时</div>
                <div :class="time==2?'xiaoshiHover':'xiaoshi'" @click="timeqieh('ri')">日均</div>
                <div :class="time==3?'xiaoshiHover':'xiaoshi'" @click="timeqieh('yue')">月均</div>
                <el-date-picker
                  v-model="value1"
                  class="custom-date-picker"
                  type="date"
                  size="small"
                  @blur="timetrpicker"
                  style="float:left;margin-left:10px;"
                  placeholder="选择日期">
                </el-date-picker>
                <div class="xiaoshiHover" @click="tanchuangshuj">查询</div>
                <div class="zsfsList">
                  展示方式：
                  <el-radio-group v-model="radio1" @input="numtab" size="small" fill="#04A66F" >
                    <el-radio-button label="折线"></el-radio-button>
                    <el-radio-button label="表格"></el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div ref="columnTrEchart" v-if="tabnum==true" style="width: 100%; height: 480px;"></div>
              <el-table
                v-else
                :data="formListVlaue"
                height="480"
                border
                style="width: 100%;">
                <el-table-column
                prop="date"
                label="时间"
                width="360">
                </el-table-column>
                <el-table-column
                prop="name"
                :label="'数值单位：' + unitValue">
                </el-table-column>
              </el-table>
              <div class="loader" v-if="lodshow==true">
                <div class="loader-inner ball-grid-pulse">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <span class="lodingspan">加载中......</span>
              </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!-- 监控 -->
    <el-dialog
      width="100%"
      top="0px"
      :visible.sync="sxtshowdialogTableVisible"
      :modal-append-to-body="false"
      v-if="sxtshowdialogTableVisible"
    >
      <div 
        class="tz_cov_zaip"
      >
        <img
          src="@/assets/images/guanbi.png"
          class="guanbiann"
          @click="qcguanbi"
          alt=""
        />
        <div class="tz_cov_topchanye" style="margin-bottom:0px;">
          <span class="tz_cov_top_tit" v-if="showSeployDes">{{ showSeployDes }}</span>
          <span class="tz_cov_top_tit" v-else>监控视频</span>
        </div>
        <div class="sxtshowcov" style="width:100%;" >
          <div :id="itemdeployCode" v-if="deviceIotUrl"></div>
          <video
            ref="video"
            class="video-js vjs-default-skin"
            style="width:100%;height:950px"
            height="950"
            controls
            autoplay
            v-else
          >
            <source :src="deviceUrl" />
          </video>
        </div>
      </div>
    </el-dialog>
    <!-- 虫情 -->
    <el-dialog
      width="70%"
      top="160px"
      :visible.sync="cqjczddialogTableVisible"
      :modal-append-to-body="false"
      v-if="cqjczddialogTableVisible"
    >
      <div class="tzcq_cov_chanye" style="height: 670px">
        <img
          src="@/assets/images/guanbi.png"
          class="guanbiann"
          @click="qcguanbi"
          alt=""
        />
        <div class="tz_cov_topchanye">
          <span class="tz_cov_top_tit">虫情监测</span>
        </div>
        <el-row class="tz_cov_topyqjs">
          <el-col :span="12">
            <span class="tcxitit">虫害实时监测</span>
            <div class="grid-content bg-purple ycboxlt4">
              <img src="@/assets/images/tcdicq.png" class="tcyqimg"  alt="">
              <img src="@/assets/images/tcdidizuo.png" class="tcdidizuoimg"  alt="">
                <img src="@/assets/images/tcdijt.png" class="tcdijtimg"  alt="">
            </div>
            <div class="cqssjcTit">
              <div class="cqssjcTwoTit">
                <div class="cqssjcThreeTit"><span>采集</span></div>
              </div>
            </div>
            <div class="cqssjcTit2">
              <div class="cqssjcTwoTit">
                <div class="cqssjcThreeTit"><span>拍照</span></div>
              </div>
            </div>
            <div class="cqssjcTit3">
              <div class="cqssjcTwoTit">
                <div class="cqssjcThreeTit"><span>预警</span></div>
              </div>
            </div>
            <div class="cqssjcTit4">
              <div class="cqssjcTwoTit">
                <div class="cqssjcThreeTit"><span>上传</span></div>
              </div>
            </div>
            <div class="cqssjcTit5">
              <div class="cqssjcTwoTit">
                <div class="cqssjcThreeTit"><span>分析</span></div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="timeStty">
                <span class="tcxitit">监测信息快照</span>
                <!-- <div class="timeright">
                  <el-date-picker
                    v-model="value1"
                    class="custom-date-picker"
                    type="date"
                    size="small"
                    style="float:left;margin-left:10px;"
                    placeholder="选择日期">
                  </el-date-picker>
                  <div class="xiaoshiHover" >查询</div>
                </div> -->
            </div>
            <div class="cqimgTcList" >
              <div class="cqimg" v-for="(item,index) in photoCqList" :key="index">
                  <viewer :images="photoCqList" >
                    <img :src="urlimg+item.value" v-for="(item,index) in photoCqList" :key="index" v-show="index==0" style="position: absolute;left:0px;top:0px;z-index: 3;width:208px;height:192px;opacity: 0;" alt="">
                  </viewer>
                  <img :src="urlimg+item.value" alt="">
                  <span class="cqTime">{{item.dataDateTime}}</span>
              </div>
            </div>
            <el-pagination
                  @current-change="handleCurrentcqChange"
                  background
                  style="margin-top:10px;"
                  layout="prev, pager, next"
                  :total="totalValue">
                </el-pagination>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!-- 孢子 -->
    <el-dialog
      width="70%"
      top="160px"
      :visible.sync="bzjczddialogTableVisible"
      :modal-append-to-body="false"
    >
      <div class="xintc">
          <div class="tz_cov_chanye" style="height: 670px">
            <img
              src="@/assets/images/guanbi.png"
              class="guanbiann"
              @click="qcguanbi"
              alt=""
            />
            <div class="tz_cov_topchanye">
              <span class="tz_cov_top_tit">孢子监测</span>
            </div>
            <el-row class="tz_cov_topyqjs">
              <el-col :span="12">
                <span class="tcxitit">虫害实时监测</span>
                <div class="grid-content bg-purple ycboxlt4">
                  <video width="1020" height="500"   autoplay="autoplay" muted="muted" loop="loop" style="width:100%;object-fit: cover;">
                    <source src="@/assets/images/tc_img_cq_pao5.webm" type="video/webm">
                  </video>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="timeStty">
                    <span class="tcxitit">监测信息快照</span>
                  
                </div>
                <div class="cqimgTcList" >
                  <div class="cqimg" v-for="(item,index) in photobzjcCqList" :key="index">
                      <viewer :images="photobzjcCqList" >
                        <img :src="urlimg+item.value" v-for="(item,index) in photobzjcCqList" :key="index" v-show="index==0" style="position: absolute;left:0px;top:0px;z-index: 3;width:208px;height:192px;opacity: 0;" alt="">
                      </viewer>
                      <img :src="urlimg+item.value" alt="">
                      <span class="cqTime">{{item.dataDateTime}}</span>
                  </div>
                </div>
                <el-pagination
                    @current-change="handleCurrentcqChange"
                    background
                    style="margin-top:20px;"
                    layout="prev, pager, next"
                    :total="totalValue">
                  </el-pagination>
              </el-col>
            </el-row>
          </div>
      </div>
    </el-dialog>
    <!-- 杀虫灯弹窗 -->
    <el-dialog
        width="70%"
        top="160px"
        :visible.sync="scdzddialogTableVisible"
        :modal-append-to-body="false"
        :destroy-on-close="true"
    >
        <div class="xintc">
            <div class="tz_cov_chanye" style="height: 670px">
              <img
                src="@/assets/images/guanbi.png"
                class="guanbiann"
                @click="qcguanbi"
                alt=""
              />
              <div class="tz_cov_topchanye">
                <span class="tz_cov_top_tit">杀虫灯监测</span>
              </div>
              <el-row class="tz_cov_topyqjs">
                <el-col :span="10">
                  <div class="grid-content bg-purple ycboxlt4">
                    <span class="tcxitit" >实时监测信息</span>
                    <div class="qxsjssjcTc" >
                      <div class="qxjcimg2">
                        <img src="@/assets/images/tcscd.png" class="tcscdimg"  alt="">
                        <img src="@/assets/images/tcdidizuo.png" class="tcdzimg"  alt="">
                        <!-- <video width="720" height="376"   autoplay="autoplay" muted="muted" loop="loop" class="tcdzimg">
                          <source src="@/assets/images/tcdidizuo.webm" type="video/webm">
                        </video> -->
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="14">
                  <span class="tcxitit">杀虫灯监测历史记录</span>
                    <div class="bianqianlist">
                      <div :class="time==1?'xiaoshiHover':'xiaoshi'" @click="timeqieh('xiao')">小时</div>
                      <div :class="time==2?'xiaoshiHover':'xiaoshi'" @click="timeqieh('ri')">日均</div>
                      <div :class="time==3?'xiaoshiHover':'xiaoshi'" @click="timeqieh('yue')">月均</div>
                      <el-date-picker
                        v-model="valuescd"
                        class="custom-date-picker"
                        type="date"
                        size="small"
                        @blur="timetrpicker"
                        style="float:left;margin-left:10px;"
                        placeholder="选择日期">
                      </el-date-picker>
                      <div class="xiaoshiHover" @click="tanchuangshuj">查询</div>
                      <div class="zsfsList">
                        展示方式：
                        <el-radio-group v-model="radio1" @input="numtab" size="small" fill="#04A66F" >
                          <el-radio-button label="折线"></el-radio-button>
                          <el-radio-button label="表格"></el-radio-button>
                        </el-radio-group>
                      </div>
                    </div>
                    <div ref="columnscdEchart" v-if="tabnum==true" style="width: 100%; height: 480px;"></div>
                    <el-table
                      v-else
                      :data="formListVlaue"
                      height="480"
                      border
                      style="width: 100%;">
                      <el-table-column
                      prop="date"
                      label="时间"
                      width="360">
                      </el-table-column>
                      <el-table-column
                      prop="name"
                      :label="'数值单位：' + unitValue">
                      </el-table-column>
                    </el-table>
                    <div class="loader" v-if="lodshow==true">
                      <div class="loader-inner ball-grid-pulse">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                      <span class="lodingspan">加载中......</span>
                    </div>
                </el-col>
              </el-row>
            </div>
        </div>
    </el-dialog>
    <!-- 预警信息 和标注 -->
    <transition name="topcov2"  appear>
      <div class="yujing"  @click="yktcshow" v-if="formattedmstype==false">  
          <span class="title" v-if="yujingSHow.total>100">100+条预警 </span>
          <span class="title" v-else>{{yujingSHow.total}}条预警 </span>
          <span class="show">查看</span>
      </div>
    </transition>
    <transition name="topcov2"  appear>
      <div :class="formattedmstype==false?'biaoqian':'biaoqianover'">
          <div class="zsList">
              <img src="@/assets/images/iconshexiangtzs.png" alt="" class="zslf">
              <span class="name">苗情监测设备</span>
          </div>
          <div class="zsList">
              <img src="@/assets/images/iconsheturangzs.png" alt="" class="zslf">
              <span class="name">土壤监测设备</span>
          </div>
          <div class="zsList">
              <img src="@/assets/images/iconqixiangzs.png" alt="" class="zslf">
              <span class="name">气象监测设备</span>
          </div>
          <div class="zsList">
              <img src="@/assets/images/iconcongqingzs.png" alt="" class="zslf">
              <span class="name">虫情监测设备</span>
          </div>
          <div class="zsList">
              <img src="@/assets/images/iconbaozizs.png" alt="" class="zslf">
              <span class="name">孢子监测设备</span>
          </div>
          <div class="zsList">
              <img src="@/assets/images/iconwenshizs.png" alt="" class="zslf">
              <span class="name">杀虫灯设备</span>
          </div>
      </div>
    </transition>
    <!-- 跳转AI -->
    <transition name="topcov" appear >
      <div class="aiCov" @click="aiclkCov">
          <div class="yuyin">
              <span>嗨!我是晋小农，您有什么问题都可以问我呦~</span>
          </div>
          <img src="@/assets/images/aiimg/touimg.png" alt="" class="jiqtou">
      </div>
    </transition> 
  </div>
</template>

<script>
import * as echarts from 'echarts';
import AMapLoader from '@amap/amap-jsapi-loader';
window._AMapSecurityConfig = {
  securityJsCode: '2797c525c09575b0d54d547b976fd5e1', // '「申请的安全密钥」',
}
// @ is an alias to /src
import TitWorld from "@/components/cyshow/listtit.vue";
import YkgkCov from "@/components/cyshow/ykgkCov.vue";
import NsjlCov from "@/components/cyshow/styj.vue";
import ZzzwCov from "@/components/cyshow/zzzwCov.vue";
import WlsbCov from "@/components/cyshow/wlsbCov.vue";
import TopCov from "@/components/cyshow/topCov.vue";
import BtmCov from "@/components/cyshow/btmCov.vue";
import { mergeImgs } from '@/assets/js/merge.js';
import { entDetail, landList, deviceStatus, nonControlDevice, getDeviceTransData, deviceSummary, plantCrops,camSurvPage  } from '@/api';  //一张图接口
import { landDetail} from'@/api'
import { mapGetters } from 'vuex';
import { nextTick } from 'vue';
export default {
  name: "cyshow",
  components: {
    TitWorld,
    YkgkCov,
    TopCov,
    BtmCov,
    NsjlCov,
    ZzzwCov,
    WlsbCov
  },
  data(){
    return{
      auths:'KBISPX',
      urlimg:this.baseImg,
      mapzddialogTableVisible: false,
      inputsous:'',
      laorshou:true,
      dikuaiHover:1,
      landListShow:[],
      planTypeListValue:[],
      landDetailShow:'',
      voCompanyShowsValue:[],
      survData:[],
      cameraValue:'',
      VideoList:'',
      mapJkList:[],
      qczddialogTableVisible: false,
      trzddialogTableVisible: false,
      sxtshowdialogTableVisible:false,
      cqjczddialogTableVisible: false,
      bzjczddialogTableVisible:false,
      scdzddialogTableVisible :false,
      time:1,
      value1: '',
      radio1: '折线',
      lodshow:true,
      tabnum:true,
      formListVlaue: [],
      dqwd:'',
      dqsd:'',
      dqyl:'',
      fengs:'',
      fengx:'',
      yuliang:'',
      zhaodu:'',
      unitValue:'',
      airDataListHome1:[],
      airDataListHome2:[],
      airValue:[],
      deployId:'',
      evalue:'',
      showSeployDes:'',
      itemdeployCode:'',
      deployValue:'',
      photoCqList:[],
      deployType:'',
      map:null,
      map2:null,
      pageSize:9,
      pageNo:1,
      areaId:'101100303',
      totalValue:0,
      mapList: [
        {
          name: '',
          image:require("@/assets/images/tudi.png"),
          lnglats: [113.668347,37.749656],
          imgicon:require("@/assets/images/tudi.png"),
          imgname:'td',
        },
      ],
      activeName: 'first',
      numbValue:'',
      onephoto:[],
      zzzwList:[],
      titName:'',
      deviceType:'camera',
      yujingSHow:{},
      photobzjcCqList:[],
      pickerOptions: {
          onPick: (obj) => {
              this.pickerMinDate = new Date(obj.minDate).getTime();
              this.pickerMaxDate = new Date(obj.maxDate).getTime();
          },
          disabledDate: (time) => {
              if (this.pickerMinDate) {
                  const day1 = 60 * 24 * 3600 * 1000
                  let maxTime = this.pickerMinDate + day1
                  let minTime = this.pickerMinDate - day1
                  return time.getTime() > maxTime || time.getTime() > new Date().getTime() || time
                      .getTime() < minTime || time.getTime() < new Date('2023-12-01')
                      .getTime()
              } else {
                  /*  - 2 * 24 * 3600 * 1000*/
                  return time.getTime() > Date.now() || time.getTime() < new Date(
                      '2023-12-01').getTime()
              }
          }
      },
      valuescd:'',
      loading:true,
      qctcShow:[],
      StoragePolygon:[],
      showTooltip: false,
      tooltipContent: '',
      tooltipStyle: {
        position: 'absolute',
        left: '0px',
        top: '0px',
        background: 'white',
        padding: '5px',
        border: '1px solid #ddd',
        borderRadius: '4px'
      },
      tabscdnum:true,
      scdres:'',
      startTime:'',
      endTime:'',
      deviceIotUrl:'',
      deviceUrl:'',
       // video暂停开始
      isPlaying: false,
      status: '未播放',
      pauseTimer: null,
      // video暂停结束
    }
  },
  created(){
    this.companyId = ''
    this.farmId =localStorage.getItem('farmId')
    // this.farmId ="1868518994267414530"
    this.entDetailApi(); //基地概况
    this.plantCropsValue();//种植作物
    this.deviceStatusCover();
    this.entNonControlDeviceCover()
    this.camSurvPageCover()
  },

  computed:{
    optionSetting(){
      return{
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        autoPlay: true, // 是否自动滚动
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
    ...mapGetters(['formattedmstype']), // 将 Vuex 状态映射到计算属性
  },
  
  mounted () {
    
  },
  methods:{
    // 跳转AI
    aiclkCov(){
      this.$router.push('/ai')
    },
    // 预警信息
    yjsouw(data){
      this.yujingSHow = data
    },
    yktcshow(){
      this.$refs.childRef.styjshow();
    },
    // 预警结束
    handleClick(tab, event) {
      console.log(tab, event);
    },
    camSurvPageCover(){
      camSurvPage(this.farmId,this.pageNo,this.pageSize,this.deviceType).then(res=>{
        this.VideoList = res.result
      })
    },
    handleCurrentChange(currentPage){
      this.pageNo = currentPage;
      camSurvPage(this.farmId,this.pageNo,this.pageSize,this.deviceType).then(res=>{
        this.VideoList = res.result
      })
    },
    entNonControlDeviceCover(){
      nonControlDevice(this.farmId).then(res=>{
          this.mapJkList = res.result
      })
    },
    // 一张图种植作物
    plantCropsValue(){
      plantCrops(this.farmId).then(res=>{
        this.zzzwList = res.result
      })
    },
    // 一张图基地概况
    entDetailApi(){
      entDetail(this.farmId).then(res=>{
        this.numbValue = res.result
        this.onephoto = res.result.companyInfo.reportList
        this.voCompanyShowsValue = res.result.screenCoordinate
        this.titName = res.result.farm
        document.title = this.titName.farmName;
        this.$store.dispatch('updateTitName', this.titName);
      })
    },
    // 物联设备
    deviceStatusCover(){
        deviceStatus(this.farmId).then(res=>{
            this.survData = res.result.survData
            if (res.result.camera) {
              this.cameraValue = res.result.camera
            }
            this.landListCover();
        })
    },
    // 一张图地块列表
    landListCover(){
      let that = this
      this.landName = ''
      landList(this.farmId,this.landName).then(res=>{
          that.landListShow = res.result
          that.$nextTick(()=>{
            that.initAMap(that.landListShow);
          });
      })
    },
    landDetailCover(){
      landDetail(this.landId).then(res=>{
          this.landDetailShow = res.result
          this.init2oneAMap(this.landDetailShow)
      })
    },
    dikuaishow(dikuaishow){
      this.$router.push({name:'cyqyShow',params: { dikuaishow: dikuaishow, companyId: this.companyId, posin:this.voCompanyShowsValue,}});
    },
    dikuaiClick(e){
      if (e=='jcxx') {
        this.dikuaiHover = 1
      } else if(e=='zypz'){
         this.dikuaiHover = 2
      }else{
         this.dikuaiHover = 3
      }
    },
    lashou(){
      this.laorshou = !this.laorshou
    },
    qcguanbi() {
      this.mapzddialogTableVisible = false;
      this.qczddialogTableVisible = false;
      this.trzddialogTableVisible = false;
      this.sxtshowdialogTableVisible = false;
      this.cqjczddialogTableVisible = false;
      this.bzjczddialogTableVisible = false
      this.scdzddialogTableVisible = false;
      this.airValue= []
    },
    // video自动停止
    onPlay() {
      this.isPlaying = true
      this.status = '播放中'
      
      // 清除之前的定时器（如果有）
      if (this.pauseTimer) {
        clearTimeout(this.pauseTimer)
      }
      
      // 设置1分钟后暂停的定时器
      this.pauseTimer = setTimeout(() => {
        this.$refs.video.pause()
        this.isPlaying = false
        this.status = '已自动暂停'
      }, 10000) // 60000毫秒 = 1分钟
    },
    onPause() {
      // 如果是自动暂停，不要清除状态
      if (this.status !== '已自动暂停') {
        this.isPlaying = false
        this.status = '已暂停'
      }
      
      // 清除定时器（如果用户手动暂停）
      if (this.pauseTimer) {
        clearTimeout(this.pauseTimer)
        this.pauseTimer = null
      }
    },
    // video自动停止结束
    // 点击作物或者地块换样式
    zuowushow(item,index,land){
       let landIds = [];
      this.cropActive = index;
      if (land) {
        landIds.push(item.landId);
      } else {
        this.landListShow.map(land => {
          land.crops.map((el) => {
            if (el.cropId == item.cropId) {
              landIds.push(land.landId);
            }
          })
        })
      }
      
      if (landIds.length > 0) {
        this.selectColor(landIds);
      }
    },
    // 通用的改变颜色的方法
    selectColor(landIds,index) {
      if(index!=undefined){
        this.landActive = index
      }
      let pathArr = [];
      let logions = []
      this.StoragePolygon.map((els) => {
        let isSet = false;
        landIds.map(landId => {
          if (landId == els._opts.extData.landId) {
            els.setOptions({
              strokeColor: '#fff',
            })
            els._opts.path.map(a => {
              pathArr.push(a)
            });
            logions.push(els)
            isSet = true;
          }
        });
        if (!isSet) {
          els.setOptions({
            strokeColor: els._opts.extData.strokeColor,
            strokeWeight: 3
          })
        }
      })
      this.map.setFitView(logions)
    },
    // 画地块
    initAMap (e) {
      AMapLoader.reset()
      AMapLoader.load({
        key: "690cf12410ac76c9e8cc457bc16e899b", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.MouseTool', 'AMap.ElasticMarker', 'AMap.PolyEditor', 'AMap.ControlBar', 'AMap.CitySearch', 'AMap.Scale'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then((AMap) => {
        // 获取到作为地图容器的DOM元素，创建地图实例
        this.map = new AMap.Map("cyswcontainer", { //设置地图容器id
            resizeEnable: true,
            center:this.voCompanyShowsValue,//地图中心点
            zoom: 17, //地图显示的缩放级别
            mapStyle: 'amap://styles/darkblue',//地图颜色可换
            layers: [new AMap.TileLayer.Satellite()],
        })
        // 高清地图
        var googleLayer = new AMap.TileLayer({
            // map: this.map,
            tileSize: 256, //切片大小，取值：256，表示切片大小为256*256，128，表示切片大小为128*128，64，表示切片大小为64*64。默认值为256
            errorUrl: '', //String        取图错误时的代替地址
            getTileUrl: function (x, y, z) {
                return 'https://map.snkoudai.com/maps/vt/lyrs=y&hl=zh-CN&gl=cn&scale=1&x=' + x + '&y=' + y + '&z=' + z + ''
            },
            zIndex: 2, //Number        图层叠加的顺序值，0表示最底层。默认zIndex：1
            zooms: [16, 22], //zooms        Array        支持的缩放级别范围，默认范围[3-18]，在PC上，取值范围为[3-18]；在移动设备上，取值范围为[3-19]
            opacity: 1, //Float        图层的透明度，取值范围[0,1]，1代表完全不透明，0代表完全透明
            // detectRetina: true, //Boolean        是否在高清屏下进行清晰度适配，默认为true。                  将根据移动设备屏幕设备像素比，采用相应的技术手段，保证图层在不同设备像素比下的清晰度。
        })
        googleLayer.setMap(this.map)
        // 高清地图结束
        //  地图的多边形遮罩
            // const path = JSON.parse(e[0].shGisPath);
            e.map(async (item)=>{

              if (item.crops && item.crops.length > 0) {
                let currurl = item.crops.map((el) => {
                  if (el.imgUrl.indexOf('http://') > -1 || el.imgUrl.indexOf('https://') > -1) {
                    return el.imgUrl
                  } else {
                    return this.urlimg + el.imgUrl
                  }
                })
                let baseimg = ''
                if (item.crops.length > 4) {
                  baseimg = await mergeImgs(currurl.slice(0, 3), 300, 300)
                } else {
                  baseimg = await mergeImgs(currurl, 300, 300)
                }
                item.baseimg = baseimg
                let marker = new AMap.ElasticMarker({
                  zooms: [2, 22],
                  map: this.map,
                  position: new AMap.LngLat(Number(item.shGisLandCenterLng), Number(item.shGisLandCenterLat)), // 经纬度对象
                  styles: [
                    {
                      icon: {
                        img: item.baseimg,
                        imageSize: [30, 30],
                        size: [30, 30], //可见区域的大小
                        anchor: [-14, -8], //锚点
                        fitZoom: 18, //最合适的级别
                        scaleFactor: 1.5, //地图放大一级的缩放比例系数
                        maxScale: 2, //最大放大比例
                        minScale: 1, //最小放大比例
                      },
                    },
                    {
                      icon: {
                        img: item.baseimg,
                        imageSize: [30, 30],
                        size: [30, 30], //可见区域的大小
                        anchor: [-14, -10], //锚点
                        fitZoom: 20, //最合适的级别
                        scaleFactor: 3, //地图放大一级的缩放比例系数
                        maxScale: 5, //最大放大比例
                        minScale: 2.4, //最小放大比例
                      },
                    },
                  ],
                  zoomStyleMapping: {
                    14: 0,
                    15: 0,
                    16: 0,
                    17: 0,
                    18: 0,
                    19: 1,
                    20: 1,
                    21: 1,
                    22: 1,
                  },
                  extData:{
                    // item:{...item}
                     title: item.landName,
                      landId: item.landId,
                      shGisLandCenterLng: item.shGisLandCenterLng,
                      shGisLandCenterLat: item.shGisLandCenterLat
                  }
                })
                marker.on('click', (val) => {
                   this.mapzddialogTableVisible = true;
                  let extData = val.target.getExtData()
                  let planTypeList = this.landListShow.filter((ele) => ele.landId == extData.landId)
                  this.planTypeListValue = planTypeList[0]
                  this.landId = planTypeList[0].landId
                  this.landDetailCover()
                })
              }
 
              let polygon = new AMap.Polygon({
                  map: this.map,
                  path: JSON.parse(item.shGisPath),
                  strokeColor: item.fillColor,
                  strokeWeight: 3,
                  fillColor: item.fillColor,
                  fillOpacity: 0.4,
                  cursor: 'pointer',
                  extData: {
                      title: item.landName,
                      landId: item.landId,
                      shGisLandCenterLng: item.shGisLandCenterLng,
                      shGisLandCenterLat: item.shGisLandCenterLat
                  },
              });
              // 地图移入弹窗
              polygon.on('mouseover', this.handleMouseOver);
              polygon.on('mouseout', this.handleMouseOut);
              // 地图移入弹窗结束
              polygon.on("click", (val)=>{
                this.mapzddialogTableVisible = true;
                 let extData = val.target.getExtData()
                let planTypeList = this.landListShow.filter((ele) => ele.landId == extData.landId)
                this.planTypeListValue = planTypeList[0]
                this.landId = planTypeList[0].landId
                this.landDetailCover()
              })
              // polygon.setMap(this.map);
              this.map.add(polygon)
              this.StoragePolygon.push(polygon)//地块换样式添加
            })
            this.$nextTick(()=>{
              setTimeout(() => {
                this.setMapMarker()
              }, 1000);
            });
        // 创建遮罩结束
      }).catch(e => {
        console.log(e)
      })
    },
    handleMouseOver(e) {
      this.showTooltip = true;
      this.tooltipContent = e.target.getExtData().title
      
      // 将地图坐标转换为屏幕坐标
      const pixel = this.map.lngLatToContainer(e.lnglat);
      this.tooltipStyle.left = `${pixel.x + -120}px`;
      this.tooltipStyle.top = `${pixel.y + -100}px`;
    },
    handleMouseOut() {
      this.showTooltip = false;
    },
    init2oneAMap (e) {
      // AMapLoader.reset()
      AMapLoader.load({
        key: "690cf12410ac76c9e8cc457bc16e899b", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then((AMap) => {
        // 获取到作为地图容器的DOM元素，创建地图实例
        this.map2 = new AMap.Map("onemapcontainer", { //设置地图容器id
             resizeEnable: true,
            center: [e.shGisLandCenterLng,e.shGisLandCenterLat],//地图中心点
            zoom: 17, //地图显示的缩放级别
            mapStyle: 'amap://styles/darkblue',//地图颜色可换
            layers: [new AMap.TileLayer.Satellite()],
        })
        // 高清地图
        var googleLayer = new AMap.TileLayer({
            // map: this.map,
            tileSize: 256, //切片大小，取值：256，表示切片大小为256*256，128，表示切片大小为128*128，64，表示切片大小为64*64。默认值为256
            errorUrl: '', //String        取图错误时的代替地址
            getTileUrl: function (x, y, z) {
                return 'https://map.snkoudai.com/maps/vt/lyrs=y&hl=zh-CN&gl=cn&scale=1&x=' + x + '&y=' + y + '&z=' + z + ''
            },
            zIndex: 2, //Number        图层叠加的顺序值，0表示最底层。默认zIndex：1
            zooms: [16, 22], //zooms        Array        支持的缩放级别范围，默认范围[3-18]，在PC上，取值范围为[3-18]；在移动设备上，取值范围为[3-19]
            opacity: 1, //Float        图层的透明度，取值范围[0,1]，1代表完全不透明，0代表完全透明
            // detectRetina: true, //Boolean        是否在高清屏下进行清晰度适配，默认为true。                  将根据移动设备屏幕设备像素比，采用相应的技术手段，保证图层在不同设备像素比下的清晰度。
        })
        googleLayer.setMap(this.map2)
        const polygon = new AMap.Polygon({
              map:this.map2,
              path: JSON.parse(e.shGisPath),
              strokeColor: e.fillColor,
              strokeWeight: 2,
              fillColor: e.fillColor,
              fillOpacity: 0.6,
              extData: {
                  title: e.landName,
                  landId: e.landId,
                  shGisLandCenterLng: e.shGisLandCenterLng,
                  shGisLandCenterLat: e.shGisLandCenterLat
              },
          });
          polygon.setMap(this.map2);
          this.map2.add(polygon)
          
      }).catch(e => {
        console.log(e)
      })
    },
    // 增加点标记
    setMapMarker () {
      let makerList = []
      if (this.landListShow.length==0) {
        this.mapList.forEach((item, i) => {
          // 创建 AMap.Icon 实例
          let icon = new window.AMap.Icon({
            size: new window.AMap.Size(37, 50), // 图标尺寸
            image: item.imgicon, // Icon的图像
            imageSize: new window.AMap.Size(37, 50), // 根据所设置的大小拉伸或压缩图片
            imageOffset: new window.AMap.Pixel(0, 0)  // 图像相对展示区域的偏移量，适于雪碧图等
          });
          //信息窗口实例
          this.infoWindow = new window.AMap.InfoWindow({
            anchor: "top-top",
            offset: new window.AMap.Pixel(-130, -220),
            content: this.$refs.infoWindow,
          });
          // 遍历生成多个标记点
          this.marker = new window.AMap.Marker({
            map: this.map,
            zIndex: 9999999,
            icon: icon, // 添加 Icon 实例
            offset: new window.AMap.Pixel(-23, -50), //icon中心点的偏移量
            position: this.voCompanyShowsValue, // 经纬度对象new AMap.LngLat(x, y)，也可以是经纬度构成的一维数组[116.39, 39.9]
            extData:{i:i}
          });
          this.marker.setLabel({
              offset: new window.AMap.Pixel(0, 20),  //设置文本标注偏移量
              direction: 'top' //设置文本标注方位
          });
          let content = this.$refs.infoWindow
          this.marker.content = content
          this.marker.on("click", this.markerClick)
          // marker.emit('click', { target: marker });// 此处是设置默认出现信息窗体
          makerList.push(this.marker)
        });
      } else {
        this.mapJkList.forEach((item, i) => {
          //信息窗口实例
          this.infoWindow = new window.AMap.InfoWindow({
            anchor: "top-top",
            offset: new window.AMap.Pixel(-130, -220),
            content: this.$refs.infoWindow,
          });
          
          let marker = new AMap.ElasticMarker({
            zooms: [2, 22],
              map: this.map,
              position: new AMap.LngLat(item.deviceLongitude, item.deviceLatitude), // 经纬度对象
              styles: [
                {
                  icon: {
                    img: this.urlimg+item.mapIcon,
                    imageSize: [32, 47],
                    size: [32, 47], //可见区域的大小
                    anchor: [-16, -12], //锚点
                    fitZoom: 18, //最合适的级别
                    scaleFactor: 1.5, //地图放大一级的缩放比例系数
                    maxScale: 1, //最大放大比例
                    minScale: 1, //最小放大比例
                    imageOffset: new window.AMap.Pixel(0, 0), 
                  },
                },
                {
                  icon: {
                    img: this.urlimg+item.mapIcon,
                    imageSize: [32, 47],
                    size: [32, 47], //可见区域的大小
                    anchor: [-14, -14], //锚点
                    fitZoom: 20, //最合适的级别
                    scaleFactor: 3, //地图放大一级的缩放比例系数
                    maxScale: 1, //最大放大比例
                    minScale: 1, //最小放大比例
                    imageOffset: new window.AMap.Pixel(0, 0), 
                  },
                },
              ],
              zoomStyleMapping: {
                14: 0,
                15: 0,
                16: 0,
                17: 0,
                18: 0,
                19: 1,
                20: 1,
                21: 1,
                22: 1,
              },
              extData:{item:item}
            })
            marker.setLabel({
              offset: new window.AMap.Pixel(0, 20),  //设置文本标注偏移量
              // content: '<div>'+ item.deployRemark +'</div>', //设置文本标注内容
              // content:item.deployRemark,
              direction: 'top' //设置文本标注方位
          })
          let content = this.$refs.infoWindow
          marker.content = content
          // 地图图标放大
          marker.on('mouseover', function() {
              marker.setOptions({
                  scale: 1.1 // 放大1.5倍
              });
          });
          
          marker.on('mouseout', function() {
              marker.setOptions({
                  scale: 1 // 恢复原始大小
              });
          });
          marker.on("click", this.markerClick)
          // marker.emit('click', { target: marker });// 此处是设置默认出现信息窗体
          makerList.push(marker)
        });
      }
      this.makerList = makerList
      this.map.add(makerList)
      // 自动适应显示想显示的范围区域
      // this.map.setFitView();
    },
    // 控制标记的信息窗体的显示
    markerClick (e) {
      this.deviceUrl=""
      let deployId = e.target.getExtData().item.id
      this.deployIdtc = e.target.getExtData().item.id
      this.evalue = e
      getDeviceTransData(deployId,this.pageNo,this.pageSize,this.startTime,this.endTime).then(res=>{
          this.airValue = res.result.data
          this.deployValue = res.result.deploy
          this.deployType = e.target.getExtData().item.deployType
          if (e.target.getExtData().item.deployType=='air') {
            this.dqwd = this.airValue[0]
            this.dqsd = this.airValue[1]
            this.dqyl = this.airValue[2]
            this.fengs = this.airValue[3]
            this.fengx = this.airValue[4]
            this.yuliang = this.airValue[5]
            this.zhaodu = this.airValue[6]
            this.cyzxshow(this.dqwd)
            this.qczddialogTableVisible = true;
          } else if(e.target.getExtData().item.deployType=='soil'){
            this.airDataListHome1 = this.airValue.slice(0,6)
            this.airDataListHome2 = this.airValue.slice(6)
            if (this.airDataListHome1[0]) {
              this.deployId = this.airDataListHome1[0].deployId
              this.itemValue = this.airDataListHome1[0].item
              this.summrayMode = 'dayhours'
              this.deviceSummaryApi()
              this.trzddialogTableVisible = true;
                this.lodshow = true	
              setTimeout(() => {
                this.echrtTrCkick()
              }, 1500);
              setTimeout(() => {
                this.lodshow = false	
              }, 2000);
              this.trzddialogTableVisible = true;
            }
          }else if(e.target.getExtData().item.deployType=='camera'){
            this.sxtshowdialogTableVisible = true;
            this.itemdeployCode = this.deployValue.deployCode
            this.showSeployDes = this.deployValue.deployRemark
            if (res.result.deploy.deviceIotUrl) {
              this.deviceIotUrl = res.result.deploy.deviceIotUrl
              setTimeout(()=>{
                this.playerList = new EZUIKit.EZUIKitPlayer({
                      id: this.deployValue.deployCode , // 视频容器ID+ 'L01'
                      accessToken: this.deployValue.ysToken,
                      url: this.deployValue.deviceIotUrl,
                      template: "standard", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
                      audio: 0, // 是否默认开启声音 0 - 关闭 1 - 开启
                      autoplay: true,
                      width:1880,
                      height:950,
                  })
              },500)
            } else {
              this.deviceUrl = this.deployValue.deviceUrl
              setTimeout(()=>{
               this.player = this.$video(this.$refs.video);
              },1500)
            }
          }else if(e.target.getExtData().item.deployType=='7_bugsurv'){
             this.cqjczddialogTableVisible = true;
             this.photoCqList= res.result.data
             this.totalValue = res.result.total
          }else if (e.target.getExtData().item.deployType=='8_sporesurv'){
            this.bzjczddialogTableVisible = true
            this.photobzjcCqList = res.result.data
            this.totalValue = res.result.total
          }else if (e.target.getExtData().item.deployType=='9_pestlight'){
              this.scdzddialogTableVisible=true;
              this.lodshow = true	
              this.qctcShow = res.result.data
              this.deployId = this.qctcShow[0].deployId
              this.summrayMode = 'dayhours'
               this.itemValue = 'ct'
              this.deviceSummaryApi()
              this.scdres = res
              setTimeout(() => {
                this.lodshow = false	
              }, 2000);
          }
      })
    },
    handleCurrentcqChange(currentPage){
      let deployId = this.deployIdtc
      let e =this.evalue
      this.pageNo = currentPage;
      getDeviceTransData(deployId,this.pageNo,this.pageSize,this.startTime,this.endTime).then(res=>{
          this.airValue = res.result.data
          this.deployValue = res.result.deploy
          this.deployType = e.target.getExtData().item.deployType
          if (e.target.getExtData().item.deployType=='air') {
            this.dqwd = this.airValue[0]?this.airValue[0]:[];
            this.dqsd = this.airValue[1]?this.airValue[1]:[];
            this.dqyl = this.airValue[2]?this.airValue[2]:[];
            this.fengs = this.airValue[3]?this.airValue[3]:[];
            this.fengx = this.airValue[4]?this.airValue[4]:[];
            this.yuliang = this.airValue[5]?this.airValue[5]:[];
            this.zhaodu = this.airValue[6]?this.airValue[6]:[];
            this.cyzxshow(this.dqwd)
            this.qczddialogTableVisible = true;
          } else if(e.target.getExtData().item.deployType=='soil'){
            this.airDataListHome1 = this.airValue.slice(0,6)
            this.airDataListHome2 = this.airValue.slice(6)
            if (this.airDataListHome1[0]) {
              this.deployId = this.airDataListHome1[0].deployId
              this.itemValue = this.airDataListHome1[0].item
              this.summrayMode = 'dayhours'
              this.deviceSummaryApi()
              this.trzddialogTableVisible = true;
                this.lodshow = true	
              setTimeout(() => {
                this.echrtTrCkick()
              }, 1500);
              setTimeout(() => {
                this.lodshow = false	
              }, 2000);
              this.trzddialogTableVisible = true;
            }
          }else if(e.target.getExtData().item.deployType=='camera'){
            this.sxtshowdialogTableVisible = true;
            this.itemdeployCode = this.deployValue.deployCode
            this.showSeployDes = this.deployValue.deployDes
            this.deviceIotUrl = res.result.deploy.deviceIotUrl
            if (this.deployValue.deviceIotUrl) {
              setTimeout(()=>{
                this.playerList = new EZUIKit.EZUIKitPlayer({
                      id: this.deployValue.deployCode , // 视频容器ID+ 'L01'
                      accessToken: this.deployValue.ysToken,
                      url: this.deployValue.deviceIotUrl,
                      template: "standard", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
                      audio: 0, // 是否默认开启声音 0 - 关闭 1 - 开启
                      autoplay: true,
                      width:1880,
                      height:950,
                  })
              },500)
            } else {
              setTimeout(()=>{
                this.player = this.$video(this.$refs.video);
                this.deviceUrl = this.deployValue.deviceUrl
              },1500)
            }
          }else if(e.target.getExtData().item.deployType=='7_bugsurv'){
             this.cqjczddialogTableVisible = true;
             this.photoCqList= res.result.data
             this.totalValue = res.result.total
          }else if (e.target.getExtData().item.deployType=='8_sporesurv'){
            this.bzjczddialogTableVisible = true
            this.photobzjcCqList = res.result.data
            this.totalValue = res.result.total
          }else if (e.target.getExtData().item.deployType=='9_pestlight'){
              this.scdzddialogTableVisible=true;
              this.lodshow = true	
              this.qctcShow = res.result.data
              this.deployId = this.qctcShow[0].deployId
              this.summrayMode = 'dayhours'
               this.itemValue = 'ct'
              this.deviceSummaryApi()
              this.scdres = res
              setTimeout(() => {
                this.lodshow = false	
              }, 2000);
          }
      })
    },
    
    // 土壤弹窗
    trzxshow(e) {
      const lisst = e.target.closest(".tcgd2"); // 定位元素
        if (lisst) { // 是否是滚动组件的某一行/列
          let itemlist  = lisst.dataset.item
          let value = JSON.parse(itemlist)
          this.deployId = value.deployId
          this.itemValue = value.item
          this.summrayMode = 'dayhours'
          this.deviceSummaryApi()
        }
      let that = this
        this.trzddialogTableVisible = true;
        that.lodshow = true	
      setTimeout(() => {
        that.echrtTrCkick()
      }, 1500);
      setTimeout(() => {
        that.lodshow = false	
      }, 2000);
    },
    startAnimate() {
        this.$nextTick(() => {
            this.$refs.myNum1.map(res=>{
              res.start()
            })
        })
    },
    // 气象
    cyzxshow(value) {
      this.time = 1
          if (value.deployId) { // 是否是滚动组件的某一行/列
            this.deployId = value.deployId
            this.itemValue = value.item
            this.summrayMode = 'dayhours'
            setTimeout(() => {
              this.deviceSummaryApi()	
            }, 500);
          }
      let that = this
        this.qczddialogTableVisible = true;
      that.lodshow = true	
      setTimeout(() => {
        that.echrtCkick()
      }, 1500);
      setTimeout(() => {
        that.lodshow = false	
      }, 2000);
    },
    timeqieh(e){
      if (e=='xiao') {
        this.time = 1
        this.lodshow = true	
        this.summrayMode = 'dayhours'
        this.startTime = ''
        setTimeout(() => {
          this.deviceSummaryApi()	
        }, 500);
      } else if(e=='ri') {
        this.time = 2
        this.lodshow = true	
        this.summrayMode = 'monthDays'
        this.startTime = ''
        setTimeout(() => {
          this.deviceSummaryApi()	
        }, 500);
      }else {
        this.time = 3
        this.lodshow = true	
        this.summrayMode = 'yearMonth'
        this.startTime = ''
        setTimeout(() => {
          this.deviceSummaryApi()	
        }, 500);
      }
    },
    tanchuangshuj(){
      this.lodshow = true
      setTimeout(() => {
        this.deviceSummaryApi()	
      }, 500);
    },
    numtab(e){
      let that = this
      if (e=='折线') {
        that.tabnum = true
        this.time = 1
        this.summrayMode = 'dayhours'
        this.lodshow = true	
        this.startTime = ''
        setTimeout(() => {
          this.deviceSummaryApi()	
        }, 500);
      } else {
        this.tabnum = false
      }
    },
  
	 timetrpicker(data){
        this.startTime = data.displayValue
      },
      // 历史数据曲线
      deviceSummaryApi(){
        let obj = {
          deployId:this.deployId,
          startTime:this.startTime,
          survItem:this.itemValue,
          auths:'',
          summrayMode: this.summrayMode,
        }
        deviceSummary(obj).then(res=>{
          let that = this
          this.trListVlaue = res.result
          this.dataListVlaue = res.result.dataList
          this.timeListVlaue = res.result.timeList
		      this.formListVlaue = res.result.formList
          this.descriptionValue = res.result.itemInfo.description
          this.unitValue = res.result.itemInfo.unit
          if (res.code==200) {
            setTimeout(() => {
			        that.lodshow = false	
              that.$nextTick(() => {
                if (this.deployType=='soil') {
                  this.echrtTrCkick();
                } else if(this.deployType=='9_pestlight') {
                  this.echrtScdCkick();
                }else {
                  this.echrtCkick();
                }
              })
            }, 1000);
          }
        })
      },
	  echrtCkick(){
			 // 基于准备好的dom，初始化echarts实例
			if (myChartqx != null && myChartqx != "" && myChartqx != undefined) {
				//  已存在则调用 dispose() 方法销毁
				myChartqx.dispose();
			}
			var myChartqx = echarts.init(this.$refs.columnzxEchart);
			// 绘制图表
			let legendData = this.descriptionValue;
			let xAxisData = this.timeListVlaue;
			let seriesData1 = this.dataListVlaue;
			let option;
			option = {
				tooltip: {
				trigger: "axis",
				backgroundColor: "rgba(13, 64, 71, 0.50)",
				borderColor: "rgba(143, 225, 252, 0.60)",
				padding: 8,
				textStyle: {
					color: "#fff",
				},
				},
				grid: {
				left: "1%",
				right: "1%",
				top: "14%",
				bottom: "2%",
				containLabel: true,
				},
				legend: {
				icon: "rect",
				top: "1%",
				itemWidth: 7, // 设置宽度
				itemHeight: 7, // 设置高度
				itemGap: 15, // 设置间距
				textStyle: {
					//图例文字的样式
					color: "#fff",
					fontSize: 14,
				},
				},
				xAxis: {
				boundaryGap: true,
				data: xAxisData,
				axisLine: {
					lineStyle: {
					color: "rgba(117, 168, 202, 0.4)",
					},
				},
				axisTick: {
					show: false,
				},
				axisLabel: {
					color: "#fff",
				},
				},
				yAxis: [
				{
					name: this.unitValue,
					type: "value",
					inverse: false,
					splitLine: {
					show: true,
					lineStyle: {
						color: "rgba(117, 168, 202, 0.3)",
						type: "dashed",
					},
					},
					axisLine: {
					show: false,
					lineStyle: {
						color: "#0A5C95",
					},
					},
					axisLabel: {
					formatter: "{value}",
					textStyle: {
						color: "#89BFE5",
						fontSize: 12,
					},
					},
					nameTextStyle: {
					color: "#89BFE5",
					padding: [0, 0, 0, 15],
					fontSize: 12,
					},
					axisTick: {
					show: false,
					},
				},
				],
				series: [
				{
					name: legendData,
					type: "line",
					symbol: "circle", //设定为实心点
					showAllSymbol: true,
					symbolSize: 0,
					smooth: true,
					itemStyle: {
					normal: {
						color: `#FFDF04`,
						lineStyle: {
						//线的颜色
						color: `#07D790`,
						width: 1.5,
						},
						areaStyle: {
						//新版渐变色实现
						color: {
							type: "linear",
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
							{
								offset: 0,
								color: "rgba(255, 223, 4, 0.2)",
							},
							{
								offset: 1,
								color: "rgba(255, 223, 4, 0.1)",
							},
							],
						},
						},
					},
					},
					data: seriesData1,
				}
				],
			};

			window.addEventListener("resize", function () {
				myChartqx.resize();
			});
			// 动态显示tootip
			// var faultByHourIndex1 = 0; //播放所在下标
			// setInterval(function () {
			// 	//使得tootip每隔三秒自动显示
			// 	myChartqx.dispatchAction({
			// 	type: "showTip", // 根据 tooltip 的配置项显示提示框。
			// 	seriesIndex: 0,
			// 	dataIndex: faultByHourIndex1,
			// 	});
			// 	faultByHourIndex1++;
			// 	if (faultByHourIndex1 >= option.series[0].data.length) {
			// 	faultByHourIndex1 = 0;
			// 	}
			// }, 1500);
			option && myChartqx.setOption(option);
	  },
    echrtScdCkick(){
			 // 基于准备好的dom，初始化echarts实例
			if (myChartqx != null && myChartqx != "" && myChartqx != undefined) {
				//  已存在则调用 dispose() 方法销毁
				myChartqx.dispose();
			}
			var myChartqx = echarts.init(this.$refs.columnscdEchart);
			// 绘制图表
			let legendData = this.descriptionValue;
			let xAxisData = this.timeListVlaue;
			let seriesData1 = this.dataListVlaue;
			let option;
			option = {
				tooltip: {
				trigger: "axis",
				backgroundColor: "rgba(13, 64, 71, 0.50)",
				borderColor: "rgba(143, 225, 252, 0.60)",
				padding: 8,
				textStyle: {
					color: "#fff",
				},
				},
				grid: {
				left: "1%",
				right: "1%",
				top: "14%",
				bottom: "2%",
				containLabel: true,
				},
				legend: {
				icon: "rect",
				top: "1%",
				itemWidth: 7, // 设置宽度
				itemHeight: 7, // 设置高度
				itemGap: 15, // 设置间距
				textStyle: {
					//图例文字的样式
					color: "#fff",
					fontSize: 14,
				},
				},
				xAxis: {
				boundaryGap: true,
				data: xAxisData,
				axisLine: {
					lineStyle: {
					color: "rgba(117, 168, 202, 0.4)",
					},
				},
				axisTick: {
					show: false,
				},
				axisLabel: {
					color: "#fff",
				},
				},
				yAxis: [
				{
					name: this.unitValue,
					type: "value",
					inverse: false,
					splitLine: {
					show: true,
					lineStyle: {
						color: "rgba(117, 168, 202, 0.3)",
						type: "dashed",
					},
					},
					axisLine: {
					show: false,
					lineStyle: {
						color: "#0A5C95",
					},
					},
					axisLabel: {
					formatter: "{value}",
					textStyle: {
						color: "#89BFE5",
						fontSize: 12,
					},
					},
					nameTextStyle: {
					color: "#89BFE5",
					padding: [0, 0, 0, 15],
					fontSize: 12,
					},
					axisTick: {
					show: false,
					},
				},
				],
				series: [
				{
					name: legendData,
					type: "line",
					symbol: "circle", //设定为实心点
					showAllSymbol: true,
					symbolSize: 0,
					smooth: true,
					itemStyle: {
					normal: {
						color: `#FFDF04`,
						lineStyle: {
						//线的颜色
						color: `#07D790`,
						width: 1.5,
						},
						areaStyle: {
						//新版渐变色实现
						color: {
							type: "linear",
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [
							{
								offset: 0,
								color: "rgba(255, 223, 4, 0.2)",
							},
							{
								offset: 1,
								color: "rgba(255, 223, 4, 0.1)",
							},
							],
						},
						},
					},
					},
					data: seriesData1,
				}
				],
			};

			window.addEventListener("resize", function () {
				myChartqx.resize();
			});
			// 动态显示tootip
			// var faultByHourIndex1 = 0; //播放所在下标
			// setInterval(function () {
			// 	//使得tootip每隔三秒自动显示
			// 	myChartqx.dispatchAction({
			// 	type: "showTip", // 根据 tooltip 的配置项显示提示框。
			// 	seriesIndex: 0,
			// 	dataIndex: faultByHourIndex1,
			// 	});
			// 	faultByHourIndex1++;
			// 	if (faultByHourIndex1 >= option.series[0].data.length) {
			// 	faultByHourIndex1 = 0;
			// 	}
			// }, 1500);
			option && myChartqx.setOption(option);
	  },
    echrtTrCkick(){
        // 基于准备好的dom，初始化echarts实例
        
          if (myChart != null && myChart != "" && myChart != undefined) {
            //  已存在则调用 dispose() 方法销毁
            myChart.dispose();
          }
          var myChart = echarts.init(this.$refs.columnTrEchart);
        // 绘制图表
        let legendData = this.descriptionValue;
        let xAxisData = this.timeListVlaue;
        let seriesData1 = this.dataListVlaue;
        let option;
        option = {
          tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(13, 64, 71, 0.50)",
          borderColor: "rgba(143, 225, 252, 0.60)",
          padding: 8,
          textStyle: {
            color: "#fff",
          },
          },
          grid: {
          left: "1%",
          right: "1%",
          top: "14%",
          bottom: "2%",
          containLabel: true,
          },
          legend: {
          icon: "rect",
          top: "1%",
          itemWidth: 7, // 设置宽度
          itemHeight: 7, // 设置高度
          itemGap: 15, // 设置间距
          textStyle: {
            //图例文字的样式
            color: "#fff",
            fontSize: 14,
          },
          },
          xAxis: {
          boundaryGap: true,
          data: xAxisData,
          axisLine: {
            lineStyle: {
            color: "rgba(117, 168, 202, 0.4)",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#fff",
          },
          },
          yAxis: [
          {
            name:this.unitValue,
            type: "value",
            inverse: false,
            splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(117, 168, 202, 0.3)",
              type: "dashed",
            },
            },
            axisLine: {
            show: false,
            lineStyle: {
              color: "#0A5C95",
            },
            },
            axisLabel: {
            formatter: "{value}",
            textStyle: {
              color: "#89BFE5",
              fontSize: 12,
            },
            },
            nameTextStyle: {
            color: "#89BFE5",
            padding: [0, 0, 0, 15],
            fontSize: 12,
            },
            axisTick: {
            show: false,
            },
          },
          ],
          series: [
          {
            name: legendData,
            type: "line",
            symbol: "circle", //设定为实心点
            showAllSymbol: true,
            symbolSize: 0,
            smooth: true,
            itemStyle: {
            normal: {
              color: `#FFDF04`,
              lineStyle: {
              //线的颜色
              color: `#07D790`,
              width: 1.5,
              },
              areaStyle: {
              //新版渐变色实现
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                {
                  offset: 0,
                  color: "rgba(255, 223, 4, 0.2)",
                },
                {
                  offset: 1,
                  color: "rgba(255, 223, 4, 0.1)",
                },
                ],
              },
              },
            },
            },
            data: seriesData1,
          }
          ],
        };

        window.addEventListener("resize", function () {
          myChart.resize();
        });
        // 动态显示tootip
        // var faultByHourIndex = 0; //播放所在下标
        // setInterval(function () {
        //   //使得tootip每隔三秒自动显示
        //   myChart.dispatchAction({
        //   type: "showTip", // 根据 tooltip 的配置项显示提示框。
        //   seriesIndex: 0,
        //   dataIndex: faultByHourIndex,
        //   });
        //   faultByHourIndex++;
        //   if (faultByHourIndex >= option.series[0].data.length) {
        //   faultByHourIndex = 0;
        //   }
        // }, 1500);
        option && myChart.setOption(option);
      }
    // 气象结束
  }
};
</script>

<style lang="less" scoped>
@import "@/assets/css/common.css";
@import "@/assets/css/home.css";
@keyframes slideIn  {
    0% {
      opacity: 0;
      transform: translateY(-30%); /* 从顶部开始 */
    }
    100% {
      opacity: 1;
      transform: translateY(0); /* 移动到正常位置 */
    }
  }
@keyframes slideOut {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-30%);
  }
}
@keyframes slideLeft {
  from {
    transform: translateX(0%); /* 从屏幕右侧开始 */
  }
  to {
    transform: translateX(-100%); /* 移动到屏幕左侧 */
  }
}
@keyframes slideRt {
  from {
    transform: translateX(0%); /* 从屏幕右侧开始 */
  }
  to {
    transform: translateX(100%); /* 移动到屏幕左侧 */
  }
}
.yqgk-enter-active {
  animation: fadeInLeft 1s linear 0s ;
}
.yqgk-leave-active {
  animation: slideLeft 1s linear 0s;
}
.dlhj-enter-to {
  animation: fadeInLeft 1.2s linear 0s ;
}
.dlhj-leave-to {
  animation: slideLeft 1.2s linear 0s;
}
.qhtz-enter-active {
  animation: fadeInLeft 1.5s linear 0s ;
}
.qhtz-leave-to {
  animation: slideLeft 1.5s linear 0s;
}
.zdcy-enter-active {
  animation: fadeInRight 1s linear 0s ;
}
.zdcy-leave-to {
  animation: slideRt 1s linear 0s;
}
.jyzt-enter-active {
  animation: fadeInRight 1.2s linear 0s ;
}
.jyzt-leave-to {
  animation: slideRt 1.2s linear 0s;
}
.znwl-enter-active {
  animation: fadeInRight 1.5s linear 0s ;
}
.znwl-leave-to {
  animation: slideRt 1.5s linear 0s;
}
.topcov-enter-active {
  animation: bounceIn 2s ease-out forwards;
  animation-delay: 1s;
  opacity: 0;
}
.topcov2-enter-active {
  animation: bounceIn 2s ease-out forwards;
  animation-delay: 1s;
  opacity: 0;
}
.topcovbtm-enter-active {
  animation: fadeIn 1.5s linear 0s ;
}
// .xialatran-enter-active {
//   animation: backInDown 1.8s ease-out forwards;
// }
// .xialatran-leave-active {
//   animation: backOutUp 1.8s ease-out forwards;
// }
.xialatran-enter-active, .xialatran-leave-active {
   transition: all 0.6s cubic-bezier(0.65, 0, 0.35, 1);
  will-change: transform, opacity;
  overflow: hidden;
}
.xialatran-enter, .xialatran-leave-to {
  transform: scaleY(0);
  transform-origin: top;
  opacity: 0;
}
.xialatran-enter-to, .xialatran-leave {
  transform: scaleY(1);
  transform-origin: top;
  opacity: 1;
}
.bakcovzz{
  .biaoqian{
    width: 160px;
    min-height: 108px;
    line-height: 108px;
    padding-bottom: 10px;
    position: absolute;
    bottom: 320px;
    left: 480px;
    z-index: 1;
    background: rgba(0, 0, 0, 0.3);
    .zsList{
      width: 100%;
      height:25px;
      line-height: 25px;
      text-align: left;
      margin-top: 10px;
      .zslf{
        width: 16px!important;
        height: 24px!important;
        float: left;
        margin-left: 10px;
        margin-right: 20px;
        margin-top: 4px;
      }
      .name{
        font-size: 14px;
        color: #fff;
      }
    }
  }
  .biaoqianover{
    width: 160px;
    min-height: 108px;
    line-height: 108px;
    padding-bottom: 10px;
    position: absolute;
    bottom: 80px;
    left: 80px;
    z-index: 1;
    background: rgba(0, 0, 0, 0.3);
    .zsList{
      width: 100%;
      height:25px;
      line-height: 25px;
      text-align: left;
      margin-top: 10px;
      .zslf{
        width: 16px!important;
        height: 24px!important;
        float: left;
        margin-left: 10px;
        margin-right: 20px;
        margin-top: 4px;
      }
      .name{
        font-size: 14px;
        color: #fff;
      }
    }
  }
  .yujing{
    width: 255px;
    height: 91px;
    line-height: 96px;
    position: absolute;
    bottom: 320px;
    right: 480px;
    z-index: 2;
    cursor: pointer;
    background: url(@/assets/images/yujing.png)no-repeat 100% 100%;
    .title{
      font-size: 16px;
      color:#F7CB6B;
      float: left;
      margin-left: 85px;
    }
    .show{
      font-size: 16px;
      color: #fff;
      float: right;
      margin-right: 24px;
    }
  }
  // 监控
  .tz_cov_zaip{
    width: 100%;
    height: 1000px;
    /* background: url(../../assets/images/tccovbak.png) no-repeat;
      background-size: 100% 100%; */
      background: rgba(15,36,69,0.7);
      border-radius: 0.5vw;
      border: 1px solid #339D94;
      text-align: center;
      overflow: hidden;
      box-shadow: 0px 0px 30px 0px rgba(14,252,255,0.8);
    position: relative;
  }
  .tz_cov_zaip .el-tabs--border-card{
      background: none;
      border: none;
      box-shadow: none;
  }
  .tz_cov_zaip .el-tabs--border-card>.el-tabs__header{
      background: none;
      border: none;
      box-shadow: none;
      margin-left: 15px;
      /* padding-left: 15px; */
  }
  .tz_cov_zaip .el-tabs__item{
      background: #0F5474;
      border: 1px solid #0089AE!important;
      margin-right: 1%!important;
      color: #C9C9C9!important;
      font-size: 16px;
      padding: 0px 15px!important;
      box-sizing: border-box;
      /* height: 40px !important; */
  }
  .tz_cov_zaip .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
      background: #0089AE;
      border: 1px solid #1A848F!important;
      margin-right: 1%!important;
      color: #fff!important;
      font-size: 16px;
      padding: 0 8px;
      box-sizing: border-box;
  }
  .tz_cov_zaip .el-tabs--border-card>.el-tabs__content{
  padding: 0;
  margin-top: 20px;
  }
  // 监控结束
  .mapLf{
    width: 600px;
    height: 1030px;
    position: absolute;
    top: -100px;
    left: 0px;
    z-index: 0;
    background: linear-gradient(to right, rgba(2, 28, 47,1) 0%,rgba(2, 28, 47,.8) 75%, rgba(2, 28, 47,.0)100%);
  }
  .mapRt{
    width: 600px;
    height: 1030px;
    position: absolute;
    top: -100px;
    right: 0px;
    z-index: 1;
    background: linear-gradient(to left, rgba(2, 28, 47,1) 0%,rgba(2, 28, 47,.8) 75%, rgba(2, 28, 47,.0)100%);
  }
  .mapBtm{
    width: 100%;
    height: 500px;
    position: absolute;
    bottom: -1080px;
    right: 0px;
    z-index: 1;
    background: linear-gradient(to top, rgb(2, 28, 47) 0%,rgba(2, 28, 47,1) 75%, rgba(0, 36, 29,.0)100%);
  }
  .mapTop{
    width: 100%;
    height: 180px;
    position: absolute;
    top: -130px;
    right: 0px;
    z-index: 1;
    background: linear-gradient(to bottom, rgba(2, 28, 47,1) 0%,rgba(2, 28, 47,1) 60%, rgba(2, 28, 47,.0)100%);
  
  }
  .jingCov{
    width: 255px;
    height: 108px;
    margin: 0 auto;
    overflow: hidden;
    text-align: left;
    background:url('@/assets/images/yujing.png');
    position: absolute;
    right: 500px;
    bottom: 320px;
    z-index: 4;
    .iimg{
      width: 56px;
      height: 64px;
      float: left;
    }
    .yiright{
      width:75%;
      height: 64px;
      line-height: 64px; 
      // background: rgba(255, 102, 102, 0.2);
      cursor: pointer;
      float: right;
      margin-top: 26px;
      margin-right: 9%;
      .tit{
        .yujinglF{
          color:#F7CB6B;
          padding-right:20px;
        }
        width:100%;
        display: block;
        color:#fff;
        text-align: right;
        white-space: nowrap;      /* 保持文本在一行内显示 */
        overflow: hidden;         /* 超出容器部分隐藏 */
        text-overflow: ellipsis; 
      }
    }
}
}
.gongsi{
  min-width: 200px;
  height: 40px;
  line-height: 40px;
  background: rgba(8, 116, 76, 0.8);
  border-radius: 40px;
  padding: 12px;
  font-size: 14px;
  color: #24F8CA;
  cursor: pointer;
  .guanbiimg{
    display: inline-block;
    margin-top: 12px;
    width: 16px;
  }
}
::v-deep.el-date-editor .el-range-input{
  background: none!important;
  color:#fff;
}
.tzcq_cov_chanye{
  width: 100%;
	height: 42vw;
    background: rgb(1 26 12 / 70%);
    border-radius: 10px;
    border: 1px solid #339D94;
    text-align: center;
    overflow: hidden;
    box-shadow: 0px 0px 30px 0px rgba(14,252,255,0.8);
    position: relative;
    overflow: hidden;
    .cqimgList{
  width: 910px;
  overflow: hidden;
  .cqimg{
    width: 302px;
    float: left;
    margin-top: 10px;
    margin-right: 0px;
    position: relative;
    img{
      width: 98%;
      height: 188px;
    }
  }
  .cqTime{
    color: #08B375;
    font-size: 16px;
    display: block;
    margin-top: 10px;
  }
}
.cqimgTcList{
  width: 98%;
  height: 500px;
  overflow: auto;
  .cqimg{
    width: 31%;
    float: left;
    margin-top: 10px;
    margin-right: 1%;
    overflow: hidden;
    position: relative;
    border-radius: 10px;
    img{
      width: 100%;
      border-radius: 10px;
      border: 1px solid rgb(0, 95, 65);
    }
  }
  .cqTime{
    color: #08B375;
    font-size: 16px;
    display: block;
    margin-top: 10px;
  }
}
/* 定义滚动条样式 */
.cqimgTcList::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.cqimgTcList::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
	border-radius: 10px;
	background-color: rgba(240, 240, 240, .0);
}
/*定义滑块 内阴影+圆角*/
.cqimgTcList::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
	background-color: rgba(36, 132, 109, .8);
}
    .guanbiann{
      width: 28px;
      height: 28px;
      position: absolute;
      right: 2%;
      top: 0.5vw;
      z-index: 9999999999;
      cursor: pointer;
    }
    .tz_cov_topchanye{
      width: 100%;
      height:48px;
      background: url(@/assets/images/tctopback.png)no-repeat ;
      background-size: 100% 100%;
      text-align: center;
      line-height: 48px;
      margin-bottom: 20px;
    }
    .tz_cov_top_tit{
      font-size: 20px;
        font-family: douyuFont;
        color: #fff;
        text-align: center;
        cursor: pointer;
    }
    .tcgldw{
      font-size: 18px;
        color: #fff;
        width: 98%;
        margin: 0 auto;
        margin-top: 10px;
        line-height: 38px;
        text-align: left;
        text-indent: 2em;
        height: 576px;
        overflow: auto;
        /* text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 15; */
    }
    /* 定义滚动条样式 */
    .tcgldw::-webkit-scrollbar {
      width: 2px;
      height: 2px;
      background-color: rgba(240, 240, 240, 0.1);
    }
    /*定义滚动条轨道 内阴影+圆角*/
    .tcgldw::-webkit-scrollbar-track {
      box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
      border-radius: 10px;
      background-color: rgba(240, 240, 240, .0);
    }
    /*定义滑块 内阴影+圆角*/
    .tcgldw::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
      background-color: rgba(36, 132, 109, .8);
    }

    .ycboxlt{
        width: 94%; margin-left: 2%;
        background: url(@/assets/images/tckuang.png)no-repeat ;
      background-size: 100% 100%;
        padding: 10px;
    }
    .ycboxlt4{
        width: 94%; margin-left: 2%;
      background-size: 100% 100%;
        padding: 10px;
    }
    .tz_cov_topyqjs{
        width: 100%;
        height:600px;
    }
    .tz_cov_top{
        width: 100%;
        height:600px;
        overflow: auto;
        animation: fadeInLeft 1s 0.02s ease backwards;
    }

    // 弹出结束

    
    .tcyqimg{
      width: 20%;
      height: 400px;
      position: absolute;
      left:11%;
      top:120px;
      z-index: 1;
    }
    .tcdidizuoimg{
      width: 40%;
      position: absolute;
      left: 2%;
      bottom: -10px;
      z-index: 0;
    }
    .tcdijtimg{
      width: 30%;
      position: absolute;
      left: 5%;
      top: 30px;
      z-index: 0;
      animation: continuous-rotation 10s linear infinite;
    }
    @keyframes continuous-rotation {
        from {
            transform: rotate(360deg);
        }
        to {
            transform: rotate(0deg);
        }
    }
    .xiaoshiHover{
        width: 48px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #04A66F;
        border-radius: 4px;
        color: #fff;
        font-size: 14px;
        float: left;
        margin-left: 10px;
        // border: 1px solid #D6D6D6;
      }
      .timeStty{
        width: 100%;
        overflow: hidden;
        margin-bottom: 10px;
        .tcxitit{
          text-align:left;font-size:14px;color:#fff;float: left;
        }
        .timeright{
          float: right;
          margin-right: 3%;
        }
      }
      .tcxitit{
      display:block;text-align:left;font-size:14px;color:#fff;margin-left:2%;
    }
    .cqssjcTit{
      width: 72px;
      height: 72px;
      border-radius: 50%;
      border: 1px solid #00FFA8;
      position: absolute;
      top: 0px;
      left: 225px;
      .cqssjcTwoTit{
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 1px dashed #00FFA8;
        margin: 0 auto;
        margin-top: 6px;
        .cqssjcThreeTit{
          width: 48px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          background: rgba(0, 255, 168,0.2);
          border-radius: 50%;
          color: #fff;
          margin: 0 auto;
          margin-top: 6px;
        }
      }
    }
    .cqssjcTit2{
      width: 72px;
      height: 72px;
      border-radius: 50%;
      border: 1px solid #00FFA8;
      position: absolute;
      top: 114px;
      left: 54px;
      .cqssjcTwoTit{
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 1px dashed #00FFA8;
        margin: 0 auto;
        margin-top: 6px;
        .cqssjcThreeTit{
          width: 48px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          background: rgba(0, 255, 168,0.2);
          border-radius: 50%;
          color: #fff;
          margin: 0 auto;
          margin-top: 6px;
        }
      }
    }
    .cqssjcTit3{
      width: 72px;
      height: 72px;
      border-radius: 50%;
      border: 1px solid #00FFA8;
      position: absolute;
      top: 110px;
      left: 394px;
      .cqssjcTwoTit{
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 1px dashed #00FFA8;
        margin: 0 auto;
        margin-top: 6px;
        .cqssjcThreeTit{
          width: 48px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          background: rgba(0, 255, 168,0.2);
          border-radius: 50%;
          color: #fff;
          margin: 0 auto;
          margin-top: 6px;
        }
      }
    }
    .cqssjcTit4{
      width: 72px;
      height: 72px;
      border-radius: 50%;
      border: 1px solid #00FFA8;
      position: absolute;
      bottom: 230px;
      left: 74px;
      .cqssjcTwoTit{
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 1px dashed #00FFA8;
        margin: 0 auto;
        margin-top: 6px;
        .cqssjcThreeTit{
          width: 48px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          background: rgba(0, 255, 168,0.2);
          border-radius: 50%;
          color: #fff;
          margin: 0 auto;
          margin-top: 6px;
        }
      }
    }
    .cqssjcTit5{
      width: 72px;
      height: 72px;
      border-radius: 50%;
      border: 1px solid #00FFA8;
      position: absolute;
      bottom: 230px;
      left: 374px;
      .cqssjcTwoTit{
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 1px dashed #00FFA8;
        margin: 0 auto;
        margin-top: 6px;
        .cqssjcThreeTit{
          width: 48px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          background: rgba(0, 255, 168,0.2);
          border-radius: 50%;
          color: #fff;
          margin: 0 auto;
          margin-top: 6px;
        }
      }
    }
}
.home_leftcy{
  width: 450px;
  margin-left: 10px;
  float: left;
  height: auto;
  position: absolute;
  left: 10px;
  top: 60px;
}
.home_rightcy{
  width: 450px;
  margin-right: 10px;
  float: right;
  height: auto;
  position: absolute;
  right: 10px;
  top: 60px;
}
// .run-leave-active {
//   animation: lightSpeedOutRight 2s linear 0s;
// }
 #cyswcontainer{
    background: #01200e;width:100%;height:1080px;position: absolute;z-index: -2;left:0;top:-122px;
}

// .zhezao{
//   width:100%;height:1080px;position: absolute;z-index: -1;left:0;bottom:0;
//   box-shadow: inset 0 -100px 200px  300px rgb(0, 0, 0,.6); /* 水平偏移|垂直偏移|模糊半径|颜色 */
// }

// 弹出开始
.dqdkxx{
  .el-dialog, .el-pager li{
    background: none;
  }
  ::v-deep .el-carousel__mask {
    display: none;
  }
  ::v-deep .el-dialog {
    // position: relative;
    // margin: 0 auto;
    background: none !important;
    // border-radius: 2px;
    // box-shadow: 0 1px 3px rgba(0,0,0,.3);
    // box-sizing: border-box;
    // width: 50%;
    /* margin-left: 22%; */
  }
  ::v-deep .el-dialog__header {
    display: none !important;
  }
  ::v-deep .carouse .el-carousel__item--card {
    width: 65% !important;
    margin-left: -40px;
  }
  .tz_cov_chanye {
    width: 100%;
    height: 42vw;
    background: rgb(1 26 12 / 80%);
    border-radius: 10px;
    border: 1px solid #339d94;
    text-align: center;
    overflow: hidden;
    box-shadow: 0px 0px 30px 0px rgba(14, 252, 255, 0.8);
    position: relative;
    overflow: hidden;
    z-index: 9;
    .jingCov2{
      width: 94%;
      height: 65px;
      margin: 0 auto;
      overflow: hidden;
      text-align: left;
      background:linear-gradient(to right, rgba(255, 102, 102, 0.2), rgba(255, 102, 102, 0));
      .iimg{
        width: 56px;
        height: 64px;
        float: left;
      }
      .yiright{
        width:84%;
        height: 64px;
        line-height: 64px; 
        // background: rgba(255, 102, 102, 0.2);
        cursor: pointer;
        float: left;
        .tit{
          width:100%;
          display: block;
          margin-left: 3%;
          color:#ffb138 ;
          white-space: nowrap;      /* 保持文本在一行内显示 */
          overflow: hidden;         /* 超出容器部分隐藏 */
          text-overflow: ellipsis; 
        }
      }
    }
    .yjList{
      width: 95%;
        height: 515px;
        overflow: auto;
    }
    /* 定义滚动条样式 */
    .yjList::-webkit-scrollbar {
      width: 2px;
      height: 2px;
      background-color: rgba(240, 240, 240, 0.1);
    }
    /*定义滚动条轨道 内阴影+圆角*/
    .yjList::-webkit-scrollbar-track {
      box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
      border-radius: 10px;
      background-color: rgba(240, 240, 240, .0);
    }
    /*定义滑块 内阴影+圆角*/
    .yjList::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
      background-color: rgba(36, 132, 109, .8);
    }
    .stCov{
      width: 99%;
      height: 60px;
      line-height: 60px;
      text-align: left;
      padding-left: 3%;
      cursor: pointer;
      background: rgba(0,24,3,0.65);
      border: 1px solid #00432B;
      span{
        width: 100%;
        font-size: 14px;
          color: #dfdfdf;
          display: block;
        white-space: nowrap;      /* 保持文本在一行内显示 */
        overflow: hidden;         /* 超出容器部分隐藏 */
        text-overflow: ellipsis; 
      }
    }
  }
  .guanbiann {
    width: 28px;
    height: 28px;
    position: absolute;
    right: 2%;
    top: 0.5vw;
    z-index: 9999999999;
    cursor: pointer;
  }
  .tz_cov_topchanye {
    width: 100%;
    height: 48px;
    background: url(@/assets/images/tctopback.png) no-repeat;
    background-size: 100% 100%;
    text-align: center;
    line-height: 48px;
    margin-bottom: 20px;
  }
  .tz_cov_top_tit {
    font-size: 20px;
    font-family: douyuFont;
    color: #fff;
    text-align: center;
  }
  .dqdkcov{
    width: 94%;
    height: 580px;
    margin: 0 auto;
    overflow: hidden;
    .qddkLf{
      width: 48%;
      float: left;
      .qddkLf_tit{
        font-size: 18px;
        color:#19CA9E ;
        display: block;
        text-align: left;
        margin-top: 30px;
      }
      .qddkLf_cov{
        width: 100%;
        height: 434px;
        border: 1px solid #03F3C4;
        margin-top: 50px;
        #onemapcontainer{
          background: #01200e;width:100%;height:434px;
        }
        .dkimg{
          width:96%;
          height: 94%;
          margin: 0 auto;
          margin-top: 2%;
        }
      }
    }
    .qddkRt{
      width: 48%;
      float: right;
      .qddkRt_top{
        width: 100%;
        height:70px;
        margin: 0 auto;
        margin-top: 20px;
        overflow: hidden;
        position: relative;
        .qddkRt_nav{
          width: 100%;
          height: 35px;
          line-height: 35px;
          margin-top: 10px;
          cursor: pointer;
          background: rgba(22,84,67,0.7);
          .qddkNav_name{
            color: #ffffff;
            width: 33.33%;
            float: left;
          }
        }
        .qddkRt_hov{
          width: 164px;
          height: 70px;
          line-height: 60px;
          cursor: pointer;
          background: url(@/assets/images/jyzt/dkdangqian.png)no-repeat 100% 100%;
          background-size: cover;
          position: absolute;
          top: 0px;
          left: 0px;
          z-index: 1;
          .tit{
            color: #1FF0B3;
            font-weight: bold;
            font-size: 16px;
            margin-right: 10px;
          }
        }
        .qddkRt_hov2{
          width: 164px;
          height: 70px;
          line-height: 60px;
          cursor: pointer;
          background: url(@/assets/images/jyzt/dkdangqian.png)no-repeat 100% 100%;
          background-size: cover;
          position: absolute;
          top: 0px;
          left: 220px;
          z-index: 1;
          .tit{
            color: #1FF0B3;
            font-weight: bold;
            font-size: 16px;
            margin-right: 10px;
          }
        }
        .qddkRt_hov3{
          width: 164px;
          height: 70px;
          line-height: 60px;
          cursor: pointer;
          background: url(@/assets/images/jyzt/dkdangqian.png)no-repeat 100% 100%;
          background-size: cover;
          position: absolute;
          top: 0px;
          right: -10px;
          z-index: 1;
          .tit{
            color: #1FF0B3;
            font-weight: bold;
            font-size: 16px;
            margin-right: 10px;
          }
        }
      }
      .qddkRt_con{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-around;
        .qddkconList{
          width:254px;
          height: 124px;
          margin-block: 20px;
          background: url(@/assets/images/jyzt/dkxinxibg.png)no-repeat 100% 100%;
          .dkname{
            font-size: 16px;
            color: #19CA9E;
            display: block;
            text-align: center;
            margin-top: 30px;
          }
          .dknum{
            font-size: 20px;
            color: #ffffff;
            display: block;
            text-align: center;
            margin-top: 10px;
            overflow: hidden;
            .nmber{
              font-family:"UnidreamLED";
              font-size: 30px;
            }
            .danwei{
              font-size: 14px;
            }
          }
        }
        .qddkconBtn{
          width:200px;
          height: 70px;
          line-height: 70px;
          text-align: center;
          margin-block: 20px;
          background: url(@/assets/images/jyzt/dkmoren.png)no-repeat 100% 100%;
          position: relative;
          cursor: pointer;
          .qddkconBtn_con{
            width: 200px;
            height: 70px;
            position: absolute;
            top: 0px;
            left: 0px;
            background: none;
          }
          .qddkconBtn_con:hover{
            width: 200px;
            height: 70px;
            position: absolute;
            top: 0px;
            left: 0px;
            background: url(@/assets/images/jyzt/dkxuanzhong.png)no-repeat 50% 100%;
            animation: fadeIn 0.5s linear 0s ;
          }
          .qddkconBtn_name{
            color: #2EE0AC;
            font-size: 16px;
            margin-top: 4px;
            display: block;
          }
        }
        .dkzyList{
          width: 94%;
          height: 120px;
          padding: 0px 3%;
          overflow: hidden;
          background:rgba(3, 99, 77,.3);
          .dkzyListimg{
            width: 90px;
            height: 90px;
            border-radius: 90px;
            background: #ffffff;
            float: left;
            margin-top: 15px;
            margin-left: 3%;
          }
          .dkzyList_rit{
            width: 76%;
            height: 90px;
            float: right;
            margin-top: 15px;
            .name{
              color:#19CA9E;
              font-size: 16px;
              display: block;
              text-align: left;
              margin-top: 10px;
            }
            .time{
              color:#19CA9E;
              font-size: 14px;
              display: block;
              text-align: left;
              margin-top: 20px;
            }
          }
        }
      }
      .qddkRt_con2{
        width: 100%;
        height: 100%;
        .qddkconList{
          width:254px;
          height: 124px;
          margin-block: 20px;
          background: url(@/assets/images/jyzt/dkxinxibg.png)no-repeat 100% 100%;
          .dkname{
            font-size: 16px;
            color: #19CA9E;
            display: block;
            text-align: center;
            margin-top: 30px;
          }
          .dknum{
            font-size: 20px;
            color: #ffffff;
            display: block;
            text-align: center;
            margin-top: 10px;
            overflow: hidden;
            .nmber{
              font-family:"UnidreamLED";
              font-size: 30px;
            }
            .danwei{
              font-size: 14px;
            }
          }
        }
        .qddkconBtn{
          width:200px;
          height: 70px;
          line-height: 70px;
          text-align: center;
          margin-block: 20px;
          background: url(@/assets/images/jyzt/dkmoren.png)no-repeat 100% 100%;
          position: relative;
          cursor: pointer;
          .qddkconBtn_con{
            width: 200px;
            height: 70px;
            position: absolute;
            top: 0px;
            left: 0px;
            background: none;
          }
          .qddkconBtn_con:hover{
            width: 200px;
            height: 70px;
            position: absolute;
            top: 0px;
            left: 0px;
            background: url(@/assets/images/jyzt/dkxuanzhong.png)no-repeat 50% 100%;
            animation: fadeIn 0.5s linear 0s ;
          }
          .qddkconBtn_name{
            color: #2EE0AC;
            font-size: 16px;
            margin-top: 4px;
            display: block;
          }
        }
        .dkzyList{
          width: 94%;
          height: 120px;
          padding: 0px 3%;
          overflow: hidden;
          background:rgba(3, 99, 77,.3);
          .dkzyListimg{
            width: 90px;
            height: 90px;
            border-radius: 90px;
            background: #ffffff;
            float: left;
            margin-top: 15px;
            margin-left: 3%;
          }
          .dkzyList_rit{
            width: 76%;
            height: 90px;
            float: right;
            margin-top: 15px;
            .name{
              color:#19CA9E;
              font-size: 16px;
              display: block;
              text-align: left;
              margin-top: 10px;
            }
            .time{
              color:#19CA9E;
              font-size: 14px;
              display: block;
              text-align: left;
              margin-top: 20px;
            }
          }
        }
      }
      .qddkRt_con3{
        width: 100%;
        height: 100%;
        overflow: hidden;
        .nsczLf{
          width: 30%;
          float: left;
          min-height: 100px;
          .nsczLf_list{
            width: 100%;
            height: 100px;
            background: #02261A;
            border: 1px solid rgb(25, 202, 158);
            box-shadow: inset 0 0 20px rgba(25, 202, 158, 1);
            margin-bottom: 14px;
            .name{
              font-size: 18px;
              color: #19CA9E;
              font-weight: bold;
              display: block;
              margin-top: 15px;
            }
            .time{
              font-size: 16px;
              color: #19CA9E;
              display: block;
              text-align: center;
              margin-top: 14px;
            }
          }
        }
        .nsczNt{
          width: 98%;
          min-height: 100px;
          float: right;
          .stCovTc {
            width: 100%;
            text-align: left;
            padding-left: 3%;
            cursor: pointer;
            padding: 10px;
            box-sizing: border-box;
            background: rgba(24,152,108,0.41);
            border: 1px solid #14A17D;
            // background: rgba(0, 24, 3, 0.65);
            // border: 1px solid #00432b;
            .imgList{
              display: flex;
              padding: 10px 0 0;
              box-sizing: border-box;
              .stCovimg{
                width: 50px;
                height: 40px;
                margin-right: 10px;
                // border: 1px solid #18bd86;
              }
            }
            span {
              width: 100%;
              font-size: 14px;
              height: 26px;
              line-height: 26px;
              color: #dfdfdf;
              display: block;
              white-space: nowrap; /* 保持文本在一行内显示 */
              overflow: hidden; /* 超出容器部分隐藏 */
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
}
// 弹出结束

/* // 右侧文本样式 */
::v-deep .el-timeline-item__content {
  margin-left: 2%;
  width: 92%;
  /* height: 50px; */
  padding-top: 0px;
}
/* // 时间样式 */
.el-timeline-item__wrapper{
  top: 0px !important;
}
::v-deep .el-timeline-item__timestamp.is-bottom {
  position: absolute;
  top: 0;
  left: 10%;
}
::v-deep .el-timeline-item__timestamp {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #fff;
  text-align: left;
  width: 90.4%;
  height: 28px;
  line-height: 28px;
  margin-left: 1%;
  padding-left: 3%;
  background: url(@/assets/images/jyzt/titleBg.png)  0 0 / 100% 100%;
}
::v-deep .el-timeline-item__timestamp.is-top{
  margin-bottom: 0px !important;
}
/* // 竖线样式 */
  ::v-deep .el-timeline-item__tail {
    position: absolute!important;
    top: 10px!important;
    left: 3%!important;
    height: 100%!important;
    width: 2px!important;
    opacity: 0.2!important;
    border-left: solid 3px #00FBBE!important;
  }
  /* // 圆点样式 */
  ::v-deep .el-timeline-item__node--normal {
    left: 0%;
    width: 28px;
    height: 28px;
    background: url(@/assets/images/qxyj.png)no-repeat 100% 100%; 
  }
  ::v-deep.el-timeline .el-timeline-item:last-child .el-timeline-item__tail{
    position: absolute!important;
    top: 10px!important;
    left: 3%!important;
    height: 100%!important;
    width: 2px!important;
    opacity: 0.2!important;
    border-left: solid 3px #00FBBE!important;
    display: block;
  }
// 气象开始
:deep .el-dialog {
    position: relative;
    margin: 0 auto;
    background: none;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    width: 50%;
    /* margin-left: 22%; */
}
:deep .el-dialog__header{
	display: none;
}
.tzqx_cov_chanye{
	width: 100%;
	height: 42vw;
    background: rgb(1 26 12 / 70%);
    border-radius: 10px;
    border: 1px solid #339D94;
    text-align: center;
    overflow: hidden;
    box-shadow: 0px 0px 30px 0px rgba(14,252,255,0.8);
    position: relative;
    overflow: hidden;
  .qxsjssjc{
	width: 100%;
	height: 366px;
	overflow: hidden;
}
.qxsjssjc_left{
	width: 25%;
	float: left;
}
.qxsjssjc_leftTc{
	width: 10%;
	position: absolute;
	left: 2%;
	top: 40px;
	z-index: 33;
}
.qxsjssjc_leftTc2{
	width: 10%;
	position: absolute;
	left: 30%;
	top: 40px;
	z-index: 33;
}
.qxjcimg2{
	width: 50%;
	height: 326px;
	float: left;
}
.qxsjssjc_left_list{
	width: 106px;
	height: 58px;
	background: url(@/assets/images/qxbg.png)no-repeat;
  background-size: 100% 100%;
    background-position: center;
    background-attachment: fixed; /* 背景图片固定 */
	// border: 1px solid #01E393;
	border-radius: 6px;
	margin-left: 3%;
	text-align: center;
	margin-top: 28px;
	cursor: pointer;
}
.qxsjssjc_left_list:hover{
  transform: scale(1.04);
}
.qxsjssjc_left_list_tit{
	width: 100%;
	height: 20px;
	text-align: center;
	line-height: 20px;
	// background-image: linear-gradient(rgba(1, 227, 147, 0.1), rgba(1, 227, 147, 0.1));
	color: #fff;
	font-size: 14px;
	border-radius: 6px 6px 0 0;
	margin-top: 4px;
}
.qxsjssjc_left_list_show{
	font-size: 16px;
	color: #01E393;
	display: inline-block;
	padding-top: 12px;
}
.qxsjssjcTc{
	width: 100%;
	height: 580px;
	overflow: hidden;
}
.tcyqimg{
    width:14%;
    position: absolute;
    left: 14%;
    bottom: 108px;
	z-index: 2;
}
.tcdzimg{
    width: 40%;
    margin-left: 5%;
    position: absolute;
    left: -4%;
    bottom: 20px;
	z-index: 0;
}
.tcxitit{
	display:block;text-align:left;font-size:14px;color:#fff;margin-left:2%;
}
// 弹出开始
:deep .el-dialog {
    position: relative;
    margin: 0 auto;
    background: none;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    width: 50%;
    /* margin-left: 22%; */
}
:deep .el-dialog__header{
	display: none;
}
.tz_cov_chanye{
	width: 100%;
	height: 42vw;
    background: rgb(1 26 12 / 70%);
    border-radius: 10px;
    border: 1px solid #339D94;
    text-align: center;
    overflow: hidden;
    box-shadow: 0px 0px 30px 0px rgba(14,252,255,0.8);
	position: relative;
	overflow: hidden;
}
.guanbiann{
	width: 28px;
	height: 28px;
	position: absolute;
	right: 2%;
	top: 0.5vw;
	z-index: 9999999999;
	cursor: pointer;
}
.tz_cov_topchanye{
	width: 100%;
	height:48px;
	background: url(@/assets/images/tctopback.png)no-repeat ;
	background-size: 100% 100%;
	text-align: center;
	line-height: 48px;
	margin-bottom: 20px;
}
.tz_cov_top_tit{
	font-size: 20px;
    font-family: douyuFont;
    color: #fff;
    text-align: center;
}
.tcgldw{
	font-size: 18px;
    color: #fff;
    width: 98%;
    margin: 0 auto;
    margin-top: 10px;
    line-height: 38px;
    text-align: left;
    text-indent: 2em;
    height: 576px;
    overflow: auto;
    /* text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 15; */
}
/* 定义滚动条样式 */
.tcgldw::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.tcgldw::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
	border-radius: 10px;
	background-color: rgba(240, 240, 240, .0);
}
/*定义滑块 内阴影+圆角*/
.tcgldw::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
	background-color: rgba(36, 132, 109, .8);
}

.ycboxlt{
    width: 94%; margin-left: 2%;
    background: url(@/assets/images/tckuang.png)no-repeat ;
	background-size: 100% 100%;
    padding: 10px;
}
.ycboxlt4{
    width: 94%; margin-left: 2%;
	background-size: 100% 100%;
    padding: 10px;
}
.tz_cov_topyqjs{
    width: 100%;
	  height:600px;
}
.tz_cov_top{
    width: 100%;
	  height:600px;
    overflow: auto;
    animation: fadeInLeft 1s 0.02s ease backwards;
}
.in1con_lf_imglf_num_jix {
	color: #63ffec;
    font-size: 16px;
    font-family: "UnidreamLED";
}

// 弹出结束

.bianqianlist{
	width: 100%;
	height: 40px;
	overflow: hidden;
	margin-top: 10px;
	.xiaoshi{
		width: 48px;
		height: 30px;
		line-height: 30px;
		border-radius: 4px;
		border: 1px solid #D6D6D6;
		border-radius: 4px;
		color: #fff;
		font-size: 14px;
		float: left;
		margin-left: 10px;
		cursor: pointer;
	}
	.xiaoshiHover{
		width: 48px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		background: #04A66F;
		border-radius: 4px;
		color: #fff;
		font-size: 14px;
		float: left;
		margin-left: 10px;
		cursor: pointer;
		// border: 1px solid #D6D6D6;
	}
	.zsfsList{
		float: right;
		color: #fff;
		font-size: 14px;
		margin-right: 20px;
	}
}
}
//气象结束
// 土壤开始
.tztr_cov_chanye{
  width: 100%;
	height: 670px;
  background: rgb(1 26 12 / 70%);
  border-radius: 10px;
  border: 1px solid #339D94;
  text-align: center;
  overflow: hidden;
  box-shadow: 0px 0px 30px 0px rgba(14,252,255,0.8);
	position: relative;
	overflow: hidden;
  .guanbiann{
	width: 28px;
	height: 28px;
	position: absolute;
	right: 2%;
	top: 10px;
	z-index: 9999999999;
	cursor: pointer;
}
.tz_cov_topchanye{
	width: 100%;
	height:48px;
	background: url(@/assets/images/tctopback.png)no-repeat ;
	background-size: 100% 100%;
	text-align: center;
	line-height: 48px;
	margin-bottom: 20px;
}
.tz_cov_top_tit{
	font-size: 20px;
    font-family: douyuFont;
    color: #fff;
    text-align: center;
}
.tcgldw{
	font-size: 18px;
    color: #fff;
    width: 98%;
    margin: 0 auto;
    margin-top: 10px;
    line-height: 38px;
    text-align: left;
    text-indent: 2em;
    height: 576px;
    overflow: auto;
    /* text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 15; */
}
/* 定义滚动条样式 */
.tcgldw::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.tcgldw::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
	border-radius: 10px;
	background-color: rgba(240, 240, 240, .0);
}
/*定义滑块 内阴影+圆角*/
.tcgldw::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
	background-color: rgba(36, 132, 109, .8);
}

.ycboxlt{
    width: 94%; margin-left: 2%;
    background: url(@/assets/images/tckuang.png)no-repeat ;
	background-size: 100% 100%;
    padding: 10px;
}
.ycboxlt4{
    width: 94%; margin-left: 2%;
	background-size: 100% 100%;
    padding: 10px;
}
.tz_cov_topyqjs{
    width: 100%;
	  height:600px;
}
.tz_cov_top{
    width: 100%;
	  height:600px;
    overflow: auto;
    animation: fadeInLeft 1s 0.02s ease backwards;
}

// 弹出结束
.qxsjssjc{
	width: 100%;
	height: 366px;
	overflow: hidden;
}
.qxsjssjc_left{
	width: 12%;
  height: 500px;
	overflow: auto;
  z-index: 3;
  position: absolute;
  left: 10px;
  top: 20px;
}
/* 定义滚动条样式 */
.qxsjssjc_left::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.qxsjssjc_left::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
	border-radius: 10px;
	background-color: rgba(240, 240, 240, .0);
}
/*定义滑块 内阴影+圆角*/
.qxsjssjc_left::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
	background-color: rgba(36, 132, 109, .8);
}
.qxsjssjc_right{
	width: 12%;
  height: 500px;
  overflow: auto;
  z-index: 3;
  position: absolute;
  left: 370px;
  top: 20px;
}
/* 定义滚动条样式 */
.qxsjssjc_right::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.qxsjssjc_right::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
	border-radius: 10px;
	background-color: rgba(240, 240, 240, .0);
}
/*定义滑块 内阴影+圆角*/
.qxsjssjc_right::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
	background-color: rgba(36, 132, 109, .8);
}
.qxjcimg2{
	width: 50%;
	height: 326px;
	float: left;
}
.qxsjssjc_left_list{
	width: 106px;
	height: 58px;
	background: url(@/assets/images/qxbg.png)no-repeat;
  background-size: 100% 100%;
    background-position: center;
    background-attachment: fixed; /* 背景图片固定 */
	// border: 1px solid #01E393;
	border-radius: 6px;
	margin-left: 3%;
	text-align: center;
	margin-top: 28px;
	cursor: pointer;
}
.qxsjssjc_left_list:hover{
  transform: scale(1.04);
}
.qxsjssjc_left_list_tit{
	width: 100%;
	height: 20px;
	text-align: center;
	line-height: 20px;
	// background-image: linear-gradient(rgba(1, 227, 147, 0.1), rgba(1, 227, 147, 0.1));
	color: #fff;
	font-size: 14px;
	border-radius: 6px 6px 0 0;
	margin-top: 4px;
}
.qxsjssjc_left_list_show{
	font-size: 16px;
	color: #01E393;
	display: inline-block;
	padding-top: 12px;
}
.qxsjssjcTc{
	width: 100%;
	height: 580px;
	overflow: hidden;
}
.tcyqimg{
    width:226px;
    height: 410px;
    position: absolute;
    left:11%;
    bottom: 100px;
	  z-index: 2;
}
.tcdzimg{
    width: 40%;
    margin-left: 5%;
    position: absolute;
    left: -5%;
    bottom: 10px;
	z-index: 1;
}
.tcxitit{
	display:block;text-align:left;font-size:14px;color:#fff;margin-left:2%;
}

.bianqianlist{
	width: 100%;
	height: 40px;
	overflow: hidden;
	margin-top: 10px;
	.xiaoshi{
		width: 48px;
		height: 30px;
		line-height: 30px;
		border-radius: 4px;
		border: 1px solid #D6D6D6;
		border-radius: 4px;
		color: #fff;
		font-size: 14px;
		float: left;
		margin-left: 10px;
		cursor: pointer;
	}
	.xiaoshiHover{
		width: 48px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		background: #04A66F;
		border-radius: 4px;
		color: #fff;
		font-size: 14px;
		float: left;
		margin-left: 10px;
    cursor: pointer;
		// border: 1px solid #D6D6D6;
	}
	.zsfsList{
		float: right;
		color: #fff;
		font-size: 14px;
		margin-right: 20px;
	}
}
.jcsjtclist{
    width: 138px;
    height: 60px;
    background: url(@/assets/images/trbg.png)no-repeat;
    background-size: 100% 100%;
    background-position: center;
    background-attachment: fixed; /* 背景图片固定 */
    border-radius: 6px;
    margin-top: 14px;
    cursor: pointer;
    .jcsjicon1{
        width: 46px;
        margin-top: 14px;
    }
    .jcsjicon1_tit{
        font-size: 14px;
        color: #fff;
        display: block;
        margin-top: 14px;
        text-align: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .jcsjicon1_num{
        color: #63ffec;
        font-size: 18px;
        font-family: "UnidreamLED";
        text-align: left;
        display: block;
    }
    .jcsjicon1_dan{
        font-size: 14px;
        color: #fff;
        margin-left: 3%;
    }
  }
.jcsjtclist:hover{
  transform: scale(1.04);
}
}
// 土壤结束

.xintc{
  /* 不可删除弹出开始，以气象为主 */
  :deep .el-dialog {
      position: relative;
      margin: 0 auto;
      background: none;
      border-radius: 2px;
      box-shadow: 0 1px 3px rgba(0,0,0,.3);
      box-sizing: border-box;
      width: 50%;
      /* margin-left: 22%; */
  }
  :deep .el-dialog__header{
    display: none;
  }
  .tz_cov_chanye{
    width: 100%;
    height: 42vw;
    /* background: url(../../assets/images/tccovbak.png) no-repeat;
    background-size: 100% 100%; */
    background: rgba(1, 17, 26, 0.8);
    border-radius: 10px;
    border: 1px solid #339d94;
    text-align: center;
    overflow: hidden;
    box-shadow: 0px 0px 30px 0px rgba(14, 252, 255, 0.8);
    position: relative;
  }
  .guanbiann{
    width: 28px;
    height: 28px;
    position: absolute;
    right: 2%;
    top: 0.5vw;
    z-index: 9999999999;
    cursor: pointer;
  }
  .tz_cov_topchanye{
    width: 100%;
    height:48px;
    background: url(@/assets/images/tctopback.png)no-repeat ;
    background-size: 100% 100%;
    text-align: center;
    line-height: 48px;
    margin-bottom: 20px;
  }
  .tz_cov_top_tit{
    font-size: 20px;
      font-family: douyuFont;
      color: #fff;
      text-align: center;
  }
  .tcgldw{
    font-size: 18px;
      color: #fff;
      width: 98%;
      margin: 0 auto;
      margin-top: 10px;
      line-height: 38px;
      text-align: left;
      text-indent: 2em;
      height: 576px;
      overflow: auto;
      /* text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 15; */
  }
  /* 定义滚动条样式 */
  .tcgldw::-webkit-scrollbar {
    width: 2px;
    height: 2px;
    background-color: rgba(240, 240, 240, 0.1);
  }
  /*定义滚动条轨道 内阴影+圆角*/
  .tcgldw::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
    border-radius: 10px;
    background-color: rgba(240, 240, 240, .0);
  }
  /*定义滑块 内阴影+圆角*/
  .tcgldw::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
    background-color: rgba(36, 132, 109, .8);
  }

  .ycboxlt{
      width: 94%; margin-left: 2%;
      background: url(@/assets/images/tckuang.png)no-repeat ;
    background-size: 100% 100%;
      padding: 10px;
  }
  .ycboxlt4{
      width: 94%; margin-left: 2%;
    background-size: 100% 100%;
      padding: 10px;
  }
  .tz_cov_topyqjs{
      width: 100%;
      height:600px;
  }
  .tz_cov_top{
      width: 100%;
      height:600px;
      overflow: auto;
      animation: fadeInLeft 1s 0.02s ease backwards;
  }
  .in1con_lf_imglf_num_jix {
    color: #12CCFA;
      font-size: 24px;
      font-family: "UnidreamLED";
  }
  .qxjcCon{
    height: 506px;
    
  }

  .qxsjssjc{
    width: 100%;
    height: 506px;
    overflow: hidden;
  }
  .qxsjssjc_left{
    width: 160px;
    float: left;
    margin-left: 40px;
  }
  .qxsjssjc_leftTc{
    width: 10%;
    position: absolute;
    left: 2%;
    top: 40px;
    z-index: 33;
  }
  .qxsjssjc_leftTc2{
    width: 10%;
    position: absolute;
    left: 30%;
    top: 40px;
    z-index: 33;
  }
  .qxjcimg2{
    width: 45%;
    float: left;
    margin-left: 40px;
    .qiyename{
      width: 304px;
      height: 40px;
      margin-left: 40px;
      margin-top: 20px;
      overflow: hidden;
      .qynammeLf{
        float: left;
        width: 34px;
        margin-top: 3px;
        cursor: pointer;
      }
      .qynammeCon{
        float: left;
        width: 234px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: url(@/assets/images/qiyename.png)no-repeat 100% 100%;
        font-size: 16px;
        color: #fff;
      }
      .qynammeRt{
        float: right;
        width: 34px;
        margin-top: 3px;
        cursor: pointer;
      }
    }
  }
  .qxsjssjc_left_list{
    width: 175px;
    height: 86px;
    background: url(@/assets/images/qxbg.png)no-repeat 100% 100%;
    border-radius: 6px;
    text-align: center;
    margin-top: 20px;
    cursor: pointer;
  }
  .qxsjssjc_left_list_tit{
    width: 100%;
    height: 20px;
    text-align: center;
    line-height: 20px;
    color: #fff;
    font-size: 14px;
    border-radius: 6px 6px 0 0;
    margin-top: 4px;
  }
  .qxsjssjc_left_list_show{
    font-size: 16px;
    color: #12CCFA;
    display: inline-block;
    padding-top: 18px;
  }
  .qxsjssjcTc{
    width: 100%;
    height: 580px;
    overflow: hidden;
  }
  .tcyqimg{
      width:14%;
      position: absolute;
      left: 14%;
      bottom: 80px;
    z-index: 2;
  }
  .tcdzimg{
      width: 40%;
      margin-left: 5%;
      position: absolute;
      left: -4%;
      bottom: -10px;
    z-index: 0;
  }
  .tcxitit{
    display:block;text-align:left;font-size:14px;color:#fff;margin-left:2%;
  }
  .bianqianlist{
    width: 100%;
    height: 40px;
    overflow: hidden;
    margin-top: 10px;
    .xiaoshi{
      width: 48px;
      height: 30px;
      line-height: 30px;
      border-radius: 4px;
      border: 1px solid #D6D6D6;
      border-radius: 4px;
      color: #fff;
      font-size: 14px;
      float: left;
      margin-left: 10px;
      cursor: pointer;
    }
    .xiaoshiHover{
      width: 48px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #04A66F;
      border-radius: 4px;
      color: #fff;
      font-size: 14px;
      float: left;
      margin-left: 10px;
      cursor: pointer;
    }
    .zsfsList{
      float: right;
      color: #fff;
      font-size: 14px;
      margin-right: 20px;
    }
  }
  // 土壤补充
  .jcsjtclist{
      width: 138px;
      height: 60px;
      background: #1D4C82;
      border-radius: 6px;
      margin-top: 14px;
      cursor: pointer;
      .jcsjicon1{
          width: 46px;
          margin-top: 14px;
      }
      .jcsjicon1_tit{
          font-size: 14px;
          color: #fff;
          display: block;
          margin-top: 14px;
          text-align: left;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
      }
      .jcsjicon1_num{
          color: #4FBFF9;
          font-size: 18px;
          font-family: "UnidreamLED";
          text-align: left;
          display: block;
      }
      .jcsjicon1_dan{
          font-size: 14px;
          color: #fff;
          margin-left: 3%;
      }
  }
  .qxsjssjc_right{
    width: 12%;
    height: 500px;
    overflow: auto;
    z-index: 3;
    position: absolute;
    left: 470px;
    top: 20px;
  }
  /* 定义滚动条样式 */
  .qxsjssjc_right::-webkit-scrollbar {
    width: 2px;
    height: 2px;
    background-color: rgba(240, 240, 240, 0.1);
  }
  /*定义滚动条轨道 内阴影+圆角*/
  .qxsjssjc_right::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
    border-radius: 10px;
    background-color: rgba(240, 240, 240, .0);
  }
  /*定义滑块 内阴影+圆角*/
  .qxsjssjc_right::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
    background-color: rgba(36, 132, 109, .8);
  }
  .tctrimg{
    width: 20%;
    height: 400px;
    position: absolute;
    left:11%;
    top:120px;
    z-index: 1;
  }
  .tcscdimg{
    width: 10%;
    height: 500px;
    position: absolute;
    left:16%;
    top:20px;
    z-index: 1;
  }
  .tcchimg{
    width: 115px;
    height: 446px;
    position: absolute;
    left:17.5%;
    top:60px;
    z-index: 1;
  }
  // 土壤补充结束
  // 虫情补充
   .tz_cov_topyqjs{
      width: 100%;
      height:600px;
  }
  .tcccqhimg{
  width: 115px;
  height: 446px;
  position: absolute;
  left:17.5%;
  top:60px;
  z-index: 1;
}
.tcdidizuoimg{
  width: 40%;
  position: absolute;
  left: 2%;
  bottom: -30px;
  z-index: 0;
}
.tcdijtimg{
  width: 34%;
   position: absolute;
  left: 4%;
  top: -40px;
  z-index: 0;
  // animation: continuous-rotation 10s linear infinite;
}
@keyframes continuous-rotation {
    from {
        transform: rotate(360deg);
    }
    to {
        transform: rotate(0deg);
    }
}
.xiaoshiHover{
		width: 48px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		background: #04A66F;
		border-radius: 4px;
		color: #fff;
		font-size: 14px;
		float: left;
		margin-left: 10px;
		cursor: pointer;
	}
  .timeStty{
    width: 100%;
    overflow: hidden;
    margin-bottom: 10px;
    .tcxitit{
      text-align:left;font-size:14px;color:#fff;float: left;
    }
    .timeright{
      float: right;
      margin-right: 3%;
    }
  }
  .tcxitit{
	display:block;text-align:left;font-size:14px;color:#fff;margin-left:2%;
}
.cqimgTcList{
  width: 100%;
  height: 480px;
  overflow: auto;
  .cqimg{
    width: 32%;
    float: left;
    margin-top: 10px;
    margin-right: 1%;
    overflow: hidden;
    position: relative;
    border-radius: 10px;
    img{
      width: 100%;
      border-radius: 10px;
      border: 1px solid rgb(0, 95, 65);
    }
  }
  .cqTime{
    color: #08B375;
    font-size: 16px;
    display: block;
    margin-top: 10px;
  }
}
/* 定义滚动条样式 */
.cqimgTcList::-webkit-scrollbar {
	width: 2px;
	height: 2px;
	background-color: rgba(240, 240, 240, 0.1);
}
/*定义滚动条轨道 内阴影+圆角*/
.cqimgTcList::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0);
	border-radius: 10px;
	background-color: rgba(240, 240, 240, .0);
}
/*定义滑块 内阴影+圆角*/
.cqimgTcList::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8);
	background-color: rgba(36, 132, 109, .8);
}
  // 虫情补充结束

  // 监控补充
  // 监控
  .tz_cov_zaip{
    width: 100%;
    height: 1000px;
    /* background: url(../../assets/images/tccovbak.png) no-repeat;
      background-size: 100% 100%; */
      background: rgba(15,36,69,0.7);
      border-radius: 0.5vw;
      border: 1px solid #33739d;
      text-align: center;
      overflow: hidden;
      box-shadow: 0px 0px 30px 0px rgba(14, 147, 255, 0.8);
    position: relative;
  }
  .tz_cov_zaip .el-tabs--border-card{
      background: none;
      border: none;
      box-shadow: none;
  }
  .tz_cov_zaip .el-tabs--border-card>.el-tabs__header{
      background: none;
      border: none;
      box-shadow: none;
      margin-left: 15px;
      /* padding-left: 15px; */
  }
  .tz_cov_zaip .el-tabs__item{
      background: #0F5474;
      border: 1px solid #0089AE!important;
      margin-right: 1%!important;
      color: #C9C9C9!important;
      font-size: 16px;
      padding: 0px 15px!important;
      box-sizing: border-box;
      /* height: 40px !important; */
  }
  .tz_cov_zaip .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
      background: #0089AE;
      border: 1px solid #1A848F!important;
      margin-right: 1%!important;
      color: #fff!important;
      font-size: 16px;
      padding: 0 8px;
      box-sizing: border-box;
  }
  .tz_cov_zaip .el-tabs--border-card>.el-tabs__content{
    padding: 0;
    margin-top: 20px;
  }
  // 监控补充结束
/* 不可删除弹出结束 */
}
</style>

<style>
/* tab列表开始 */
/* 定义滚动条样式 */
.el-table__body-wrapper::-webkit-scrollbar {
	width: 2px!important;
	height: 0px!important;
	background-color: rgba(240, 240, 240, 0.1)!important;
}
/*定义滚动条轨道 内阴影+圆角*/
.el-table__body-wrapper::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0)!important;
	border-radius: 10px!important;
	background-color: rgba(240, 240, 240, .0)!important;
}
/*定义滑块 内阴影+圆角*/
.el-table__body-wrapper::-webkit-scrollbar-thumb {
	border-radius: 10px!important;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8)!important;
	background-color: rgba(36, 132, 109, .8)!important;
}
.el-table--border, .el-table--group{
	background: none;
	border: none;
	color: #fff;
}
.el-table th, .el-table tr{
	background: none;
	border: none;
	color: #00e99b;
	text-align: center;
}
.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
	border: none;
	text-align: center;
}
.el-table--border::after, .el-table--group::after, .el-table::before{
	background: none;
}
.el-table--enable-row-hover .el-table__body tr:hover>td{
	background: rgba(0, 54, 14, 0.6);
}
/* tab列表结束 */
.custom-date-picker .el-input__inner {
  /* 修改输入框背景色 */
  background-color: rgba(0, 0, 0, .2);
  /* 修改输入框边框颜色 */
  border-color: #d3dce6;
  color: #fff;
}
 
.custom-date-picker .el-input__prefix {
  /* 修改前缀图标颜色，如果有的话 */
  color: #fff;
}
 
.custom-date-picker .el-date-editor .el-range-separator {
  /* 修改日期选择器范围分隔符颜色和背景色 */
  color: #303133;
  background-color: #f0f0f0;
}
 
.custom-date-picker .el-popper[x-placement^="bottom"] .el-picker-panel {
  /* 修改日期选择面板的背景色 */
  background-color: #fff;
}
 
.custom-date-picker .el-picker-panel__body-wrapper .el-date-table td.current {
  /* 修改当前日期单元格的背景色 */
  background-color: #f0f0f0;
  color: #303133;
}
 
.custom-date-picker .el-picker-panel__body-wrapper .el-date-table td.today {
  /* 修改今天日期单元格的背景色和边框色 */
  background-color: #ecf5ff;
  color: #409eff;
}
 
.custom-date-picker .el-picker-panel__body-wrapper .el-date-table .el-date-table__row {
  /* 修改日期单元格的边框颜色 */
  border-color: #e4e7ed;
}
 
.custom-date-picker .el-picker-panel__body-wrapper .el-date-table .el-date-table__row:hover {
  /* 修改日期单元格hover状态的背景色 */
  background-color: #f0f0f0;
}
/* 输入框修改结束 */

/* 加载动图 */
.loader{
	width:59%;
	height: 530px;
	position: absolute;
	top: 70px;
	right: 0;
	z-index: 2;
	background: rgba(0, 0, 0, 0.5);
}
@keyframes ball-grid-pulse {
        0% {
                -webkit-transform: scale(1);
                transform: scale(1);
        }

        50% {
                -webkit-transform: scale(0.5);
                transform: scale(0.5);
                opacity: 0.7;
        }

        100% {
                -webkit-transform: scale(1);
                transform: scale(1);
                opacity: 1;
        }
}

.ball-grid-pulse {
        width: 57px;
		display: block;
		overflow: hidden;
		margin: 0 auto;
		margin-top: 200px;
}
.lodingspan{
	width: 100%;
	display: block;
	font-size: 16px;
	color: #fff;
	margin-top: 20px;
}

.ball-grid-pulse>div:nth-child(1) {
        -webkit-animation-delay: -0.06s;
        animation-delay: -0.06s;
        -webkit-animation-duration: 0.72s;
        animation-duration: 0.72s;
}

.ball-grid-pulse>div:nth-child(2) {
        -webkit-animation-delay: 0.25s;
        animation-delay: 0.25s;
        -webkit-animation-duration: 1.02s;
        animation-duration: 1.02s;
}

.ball-grid-pulse>div:nth-child(3) {
        -webkit-animation-delay: -0.17s;
        animation-delay: -0.17s;
        -webkit-animation-duration: 1.28s;
        animation-duration: 1.28s;
}

.ball-grid-pulse>div:nth-child(4) {
        -webkit-animation-delay: 0.48s;
        animation-delay: 0.48s;
        -webkit-animation-duration: 1.42s;
        animation-duration: 1.42s;
}

.ball-grid-pulse>div:nth-child(5) {
        -webkit-animation-delay: 0.31s;
        animation-delay: 0.31s;
        -webkit-animation-duration: 1.45s;
        animation-duration: 1.45s;
}

.ball-grid-pulse>div:nth-child(6) {
        -webkit-animation-delay: 0.03s;
        animation-delay: 0.03s;
        -webkit-animation-duration: 1.18s;
        animation-duration: 1.18s;
}

.ball-grid-pulse>div:nth-child(7) {
        -webkit-animation-delay: 0.46s;
        animation-delay: 0.46s;
        -webkit-animation-duration: 0.87s;
        animation-duration: 0.87s;
}

.ball-grid-pulse>div:nth-child(8) {
        -webkit-animation-delay: 0.78s;
        animation-delay: 0.78s;
        -webkit-animation-duration: 1.45s;
        animation-duration: 1.45s;
}

.ball-grid-pulse>div:nth-child(9) {
        -webkit-animation-delay: 0.45s;
        animation-delay: 0.45s;
        -webkit-animation-duration: 1.06s;
        animation-duration: 1.06s;
}

.ball-grid-pulse>div {
        background-color: #fff;
        width: 15px;
        height: 15px;
        border-radius: 100%;
        margin: 2px;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        display: inline-block;
        float: left;
        -webkit-animation-name: ball-grid-pulse;
        animation-name: ball-grid-pulse;
        -webkit-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
        -webkit-animation-delay: 0;
        animation-delay: 0;
}
/* 加载动图结束 */
</style>
<style>
.el-pagination,.el-pagination__total,.el-pagination__jump,.el-pager li.btn-quicknext,.el-select-dropdown__item{
	    color: #fff !important;
	}
	.el-pagination .btn-next, .el-pagination .btn-prev{
	    background: center center no-repeat rgba(0,0,0,.3) !important;
	    color: #fff !important;
	}
	.el-pager li{
	    background: rgba(0, 77, 29, 0.9) !important;
	}
	.el-input__inner{
	    color: #fff !important;
	    border: 1px solid #00943e !important;
	    background-color:  rgba(0,0,0,.3) !important
	}
	.el-select-dropdown{
	    border: 1px solid #00943e !important;
	    background:  rgba(0,0,0,.3) !important
	}
	.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
	    background:  #009b3b !important
	}
  .el-timeline-item__timestamp2 {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #fff;
  text-align: left;
  width: 98%;
  height: 28px;
  line-height: 28px;
  margin-left: -1%;
  padding-left: 3%;
  background: url(../assets/images/gdtime.png)0 0 / 100% 100%;
  overflow: hidden;
  display: block;
}
.el-timeline-item{
  padding-top: 10px;
  padding-bottom: 0px;
}

/* tab列表开始 */
/* 移除整个表格的背景 */
.el-table {
  background-color: transparent !important;
  border: none!important;
}

/* 移除表头背景 */
.el-table th {
  background-color: transparent !important;
  border: none!important;
}

/* 移除表格行背景 */
.el-table tr {
  background-color: transparent !important;
  border: none!important;
}

/* 移除斑马纹效果（如果有的话） */
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: transparent !important;
  border: none!important;
}
/* 定义滚动条样式 */
.el-table__body-wrapper::-webkit-scrollbar {
	width: 2px!important;
	height: 0px!important;
	background-color: rgba(240, 240, 240, 0.1)!important;
}
/*定义滚动条轨道 内阴影+圆角*/
.el-table__body-wrapper::-webkit-scrollbar-track {
	box-shadow: inset 0 0 0px rgba(240, 240, 240, .0)!important;
	border-radius: 10px!important;
	background-color: rgba(240, 240, 240, .0)!important;
}
/*定义滑块 内阴影+圆角*/
.el-table__body-wrapper::-webkit-scrollbar-thumb {
	border-radius: 10px!important;
	box-shadow: inset 0 0 0px rgba(36, 132, 109, .8)!important;
	background-color: rgba(36, 132, 109, .8)!important;
}
.el-table--border, .el-table--group{
	background: none;
	border: none!important;
	color: #fff;
}
.el-table th, .el-table tr{
	background: none;
	border: none!important;
	color: #01fffa;
	text-align: center;
}
.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
	border: none!important;
	text-align: center;
}
.el-table--border::after, .el-table--group::after, .el-table::before{
	background: none!important;
  border: none!important;
}
.el-table--enable-row-hover .el-table__body tr:hover>td{
	background: rgba(4, 74, 87, 0.6)!important;
  border: none!important;
}
/* tab列表结束 */
</style>